import React, { useEffect, useState, useCallback } from 'react';
import env from "../../config/env.js";
import { getHeaders } from "../../utils/apiUtils";
// import { criarLogAuth } from "../../utils/apiUtils"; // Removido - não utilizado
import {
  Box, Paper, Typography, FormControl, InputLabel, Select, MenuItem, TextField,
  CircularProgress, Alert, Checkbox, FormControlLabel, Button, List, ListItem,
  ListItemText, ListItemSecondaryAction, Divider, Dialog, DialogTitle, DialogContent,
  DialogActions, IconButton, Tabs, Tab, Autocomplete, Card, CardContent, Grid,
  Snackbar
  // useTheme // Removido - não utilizado
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';
import { 
  CheckCircle, Cancel, Save, Close, Assessment, People, 
  CalendarToday, School, BarChart, Timeline, FilterList, Print,
  Description, Person, AccessTime as AccessTimeIcon
} from '@mui/icons-material';
import AcessoRestrito from '../../components/AcessoRestrito';

// Recharts Components
import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import { verificarAcessoUsuario } from '../../utils/authStandards';
import { 
  formatarData, 
  formatarMoedaInput, 
  converterMoedaParaNumero, 
  formatarMoeda,
  formatarCPF,
  formatarCNPJ,
  formatarCEP,
  formatarTelefone
} from '../../utils/formatadores';
import api from '../../services/api';

// Interceptor para tratamento de erros (Regra 10)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

// Array estático para status de presença (Regra 15) - removido por não ser utilizado

// Função para desabilitar dias não válidos no calendário - removida por não ser utilizada

// Função para formatar data de YYYY-MM-DD para DD/MM/AAAA
const formatarDataExibicao = (data) => {
  if (!data) return '';
  return formatarData(data);
};

// Função para formatar percentuais
const formatarPercentual = (valor) => {
  if (!valor && valor !== 0) return '0%';
  const numero = typeof valor === 'string' ? parseFloat(valor) : valor;
  return `${numero.toFixed(1)}%`;
};

// Função para converter data de DD/MM/AAAA para YYYY-MM-DD
const converterDataParaAPI = (dataFormatada) => {
  if (!dataFormatada) return '';
  
  // Se já estiver no formato YYYY-MM-DD, retorna como está
  if (dataFormatada.includes('-')) return dataFormatada;
  
  // Remove caracteres não numéricos
  const numeros = dataFormatada.replace(/\D/g, '');
  
  // Se tem 8 dígitos, converte DDMMAAAA para YYYY-MM-DD
  if (numeros.length === 8) {
    const dia = numeros.substring(0, 2);
    const mes = numeros.substring(2, 4);
    const ano = numeros.substring(4, 8);
    return `${ano}-${mes}-${dia}`;
  }
  
  return dataFormatada;
};

// Função para formatar entrada de data em tempo real (DD/MM/AAAA) - removida por não ser utilizada

// Função para validar se uma data está no formato DD/MM/AAAA - removida por não ser utilizada

export default function RegistroFrequencia() {
  // Validação de acesso ao módulo (Regra 8)
  const acessoPermitido = verificarAcessoUsuario('registrofrequencia');

  // Estado para Dialog
  const [openDialog, setOpenDialog] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [cardSelecionado, setCardSelecionado] = useState(null);

  // Estado para turmas
  const [turmas, setTurmas] = useState([]);
  const [turmasOrdenadas, setTurmasOrdenadas] = useState([]);
  const [turmaSelecionada, setTurmaSelecionada] = useState(null);
  const [loadingTurmas, setLoadingTurmas] = useState(false);
  const [erroTurmas, setErroTurmas] = useState(null);

  // Estado para data e alunos
  const [dataSelecionada, setDataSelecionada] = useState('');
  const [datasValidas, setDatasValidas] = useState([]);
  const [alunos, setAlunos] = useState([]);
  const [loadingAlunos, setLoadingAlunos] = useState(false);
  const [erroAlunos, setErroAlunos] = useState(null);
  const [registroExistente, setRegistroExistente] = useState(null);

  // Estado para presença
  const [presenca, setPresenca] = useState({});
  const [observacoes, setObservacoes] = useState({});
  const [salvando, setSalvando] = useState(false);

  // Estado para lista de chamada impressa
  const [openListaChamada, setOpenListaChamada] = useState(false);
  const [turmaListaChamada, setTurmaListaChamada] = useState(null);
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [dadosListaChamada, setDadosListaChamada] = useState([]);
  const [loadingListaChamada, setLoadingListaChamada] = useState(false);

  // Estado para relatório de certificação
  const [openCertificacao, setOpenCertificacao] = useState(false);
  const [turmaCertificacao, setTurmaCertificacao] = useState(null);
  const [minPresenca, setMinPresenca] = useState(75);
  const [dadosCertificacao, setDadosCertificacao] = useState([]);
  const [loadingCertificacao, setLoadingCertificacao] = useState(false);

  // Estado para relatório detalhado
  const [openDetalhado, setOpenDetalhado] = useState(false);
  const [turmaDetalhado, setTurmaDetalhado] = useState(null);
  const [dataInicioDetalhado, setDataInicioDetalhado] = useState('');
  const [dataFimDetalhado, setDataFimDetalhado] = useState('');
  const [dataInicioDetalhadoFormatada, setDataInicioDetalhadoFormatada] = useState('');
  const [dataFimDetalhadoFormatada, setDataFimDetalhadoFormatada] = useState('');
  const [dadosDetalhado, setDadosDetalhado] = useState({});
  const [loadingDetalhado, setLoadingDetalhado] = useState(false);

  // Estado para relatório por aluno
  const [openPorAluno, setOpenPorAluno] = useState(false);
  const [alunoSelecionado, setAlunoSelecionado] = useState(null);
  const [dadosPorAluno, setDadosPorAluno] = useState([]);
  const [loadingPorAluno, setLoadingPorAluno] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [clientesOrdenados, setClientesOrdenados] = useState([]);
  const [loadingClientes, setLoadingClientes] = useState(false);

  // Estado para relatório por turma
  const [openPorTurma, setOpenPorTurma] = useState(false);
  const [turmaPorTurma, setTurmaPorTurma] = useState(null);
  const [dadosPorTurma, setDadosPorTurma] = useState({});
  const [loadingPorTurma, setLoadingPorTurma] = useState(false);
  const [dadosGraficoTurmas, setDadosGraficoTurmas] = useState([]);
  const [loadingGraficoTurmas, setLoadingGraficoTurmas] = useState(false);

  // Estado para estatísticas gerais
  const [openEstatisticas, setOpenEstatisticas] = useState(false);
  const [dadosEstatisticas, setDadosEstatisticas] = useState({});
  const [loadingEstatisticas, setLoadingEstatisticas] = useState(false);

  // Estado para histórico de frequência
  const [openHistorico, setOpenHistorico] = useState(false);
  const [turmaHistorico, setTurmaHistorico] = useState(null);
  const [periodoHistorico, setPeriodoHistorico] = useState('30'); // 7, 30, 90, 365 dias
  const [dadosHistorico, setDadosHistorico] = useState({});
  const [loadingHistorico, setLoadingHistorico] = useState(false);

  // Estado para filtros avançados
  const [openFiltros, setOpenFiltros] = useState(false);
  const [filtrosConfig, setFiltrosConfig] = useState({
    turma: null,
    aluno: null,
    dataInicio: '',
    dataFim: '',
    statusPresenca: 'todos', // todos, presente, ausente
    frequenciaMinima: 0,
    frequenciaMaxima: 100
  });
  const [resultadosFiltros, setResultadosFiltros] = useState([]);
  const [loadingFiltros, setLoadingFiltros] = useState(false);

  // Estado para relatório por data
  const [openPorData, setOpenPorData] = useState(false);
  const [turmaPorData, setTurmaPorData] = useState(null);
  const [dadosPorData, setDadosPorData] = useState({});
  const [loadingPorData, setLoadingPorData] = useState(false);

  useEffect(() => {
    const carregarTurmas = async () => {
      setLoadingTurmas(true);
      setErroTurmas(null);
      try {
        const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
        const res = await api.get(`/horarioAtendimento?st_codHashEmpresa=${codHashEmpresa}`);
        setTurmas(res.data || []);
      } catch (err) {
        setErroTurmas('Erro ao carregar turmas.');
      } finally {
        setLoadingTurmas(false);
      }
    };
    carregarTurmas();
  }, []);

  // Carregar clientes
  useEffect(() => {
    const carregarClientes = async () => {
      setLoadingClientes(true);
      try {
        const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
        const res = await api.get(`/clientes?st_codHashEmpresa=${codHashEmpresa}`);
        setClientes(res.data || []);
      } catch (err) {
        console.error('Erro ao carregar clientes:', err);
      } finally {
        setLoadingClientes(false);
      }
    };
    carregarClientes();
  }, []);

  // Ordenar clientes quando forem carregados
  useEffect(() => {
    if (Array.isArray(clientes) && clientes.length > 0) {
      const ordenados = [...clientes].sort((a, b) => {
        const nomeA = (a.nome_completo || a.nome || '').toLowerCase();
        const nomeB = (b.nome_completo || b.nome || '').toLowerCase();
        return nomeA.localeCompare(nomeB);
      });
      setClientesOrdenados(ordenados);
    } else {
      setClientesOrdenados([]);
    }
  }, [clientes]);

  // Ordenar turmas quando forem carregadas
  useEffect(() => {
    if (Array.isArray(turmas) && turmas.length > 0) {
      const ordenadas = [...turmas].sort((a, b) => {
        const nomeA = (a.nome || a.codigoTurma || '').toLowerCase();
        const nomeB = (b.nome || b.codigoTurma || '').toLowerCase();
        return nomeA.localeCompare(nomeB);
      });
      setTurmasOrdenadas(ordenadas);
    } else {
      setTurmasOrdenadas([]);
    }
  }, [turmas]);

  // Função para carregar gráfico de turmas
  const carregarGraficoTurmas = useCallback(async () => {
    setLoadingGraficoTurmas(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      
      // Buscar dados de todas as turmas com situação "aberto"
      const url = `/registrofrequencia/grafico-turmas?st_codHashEmpresa=${codHashEmpresa}`;
      
      const response = await api.get(url);
      
      
      // Processar dados para o gráfico
      const dadosProcessados = response.data || [];
      setDadosGraficoTurmas(dadosProcessados);
      
      // Log de auditoria
      await criarLogAuth(
        "VISUALIZACAO",
        "Carregou gráfico de presenças X faltas de todas as turmas abertas",
        "GET",
        url
      );
      
    } catch (err) {
      console.error('❌ Erro ao carregar gráfico de turmas:', err);
      // Não mostrar alerta, apenas log do erro
    } finally {
      setLoadingGraficoTurmas(false);
    }
  }, []);

  // Carregar gráfico de turmas quando abrir o relatório por turma
  useEffect(() => {
    if (openPorTurma) {
      carregarGraficoTurmas();
    }
  }, [openPorTurma, carregarGraficoTurmas]);

  // Carregar alunos quando turma e data forem selecionados
  useEffect(() => {
    if (turmaSelecionada && dataSelecionada) {
      carregarAlunos();
    } else {
      setAlunos([]);
      setPresenca({});
      setObservacoes({});
    }
  }, [turmaSelecionada, dataSelecionada]);

  // Função para calcular datas válidas baseada no período e dias da semana da turma
  const calcularDatasValidas = useCallback(() => {
    if (!turmaSelecionada) return;

    const { diaInicio, diaFim, diasDaSemana } = turmaSelecionada;
    
    if (!diaInicio || !diaFim || !diasDaSemana) {
      setDatasValidas([]);
      return;
    }

    // Converter datas para objetos Date
    const dataInicio = new Date(diaInicio);
    const dataFim = new Date(diaFim);
    
    // Mapeamento dos dias da semana
    const mapeamentoDias = {
      'domingo': 0, 'segunda': 1, 'terca': 2, 'quarta': 3, 'quinta': 4, 'sexta': 5, 'sabado': 6,
      'Domingo': 0, 'Segunda': 1, 'Terca': 2, 'Quarta': 3, 'Quinta': 4, 'Sexta': 5, 'Sabado': 6,
      'DOMINGO': 0, 'SEGUNDA': 1, 'TERCA': 2, 'QUARTA': 3, 'QUINTA': 4, 'SEXTA': 5, 'SABADO': 6,
      '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6
    };

    // Converter string de dias da semana para array de números
    let diasSemanaArray = [];
    if (diasDaSemana.includes(',')) {
      diasSemanaArray = diasDaSemana.split(',').map(dia => dia.trim());
    } else {
      diasSemanaArray = [diasDaSemana];
    }

    // Converter para números dos dias da semana
    const diasSemanaNumeros = diasSemanaArray.map(dia => mapeamentoDias[dia]).filter(dia => dia !== undefined);

    if (diasSemanaNumeros.length === 0) {
      setDatasValidas([]);
      return;
    }

    // Gerar todas as datas válidas
    const datasValidas = [];
    const dataAtual = new Date(dataInicio);
    
    while (dataAtual <= dataFim) {
      const diaSemana = dataAtual.getDay();
      
      // Verificar se o dia da semana está na lista de dias da turma
      if (diasSemanaNumeros.includes(diaSemana)) {
        // Formatar data para YYYY-MM-DD
        const dataFormatada = dataAtual.toISOString().split('T')[0];
        datasValidas.push(dataFormatada);
      }
      
      // Avançar para o próximo dia
      dataAtual.setDate(dataAtual.getDate() + 1);
    }

    setDatasValidas(datasValidas);
    
    // Se a data selecionada não estiver mais válida, limpar
    if (dataSelecionada && !datasValidas.includes(dataSelecionada)) {
      setDataSelecionada('');
    }
  }, [turmaSelecionada, dataSelecionada]);

  // Calcular datas válidas quando turma for selecionada
  useEffect(() => {
    if (turmaSelecionada) {
      calcularDatasValidas();
    } else {
      setDatasValidas([]);
      setDataSelecionada('');
    }
  }, [turmaSelecionada, calcularDatasValidas]);

  const carregarAlunos = async () => {
    setLoadingAlunos(true);
    setErroAlunos(null);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      
      
      // Buscar registros de frequência existentes para esta turma
      const res = await api.get(`/registrofrequencia?st_codHashEmpresa=${codHashEmpresa}&codigoTurma=${turmaSelecionada.codigoTurma}`);

      // Se já existe registro para esta data, carregar dados existentes
      const registrosExistentes = res.data || [];
      const registroData = registrosExistentes.find(r => r.data === dataSelecionada);

      if (registroData && registroData.alunos) {
        setRegistroExistente(registroData);
        
        const presencaExistente = {};
        const observacoesExistentes = {};

        registroData.alunos.forEach(aluno => {
          presencaExistente[aluno.id_cliente] = aluno.presente;
          if (aluno.observacao) {
            observacoesExistentes[aluno.id_cliente] = aluno.observacao;
          }
        });

        setPresenca(presencaExistente);
        setObservacoes(observacoesExistentes);
      } else {
        setRegistroExistente(null);
      }

      // Buscar alunos matriculados na turma usando o endpoint específico
      const resMatriculas = await api.get(`/matricula?st_codHashEmpresa=${codHashEmpresa}&codigoTurma=${turmaSelecionada.codigoTurma}`);
      const matriculas = resMatriculas.data || [];

      // Buscar dados dos clientes para obter nomes completos
      const resClientes = await api.get(`/clientes?st_codHashEmpresa=${codHashEmpresa}`);
      const clientes = resClientes.data || [];

      // Combinar dados de matrículas e clientes
      const alunosCompletos = matriculas.map(matricula => {
        const cliente = clientes.find(c => c.id === matricula.id_cliente);
        return {
          id_cliente: matricula.id_cliente,
          id_matricula: matricula.id_matricula || matricula.id,
          nome: cliente ? (cliente.nome || cliente.nome_completo) : `Cliente ${matricula.id_cliente}`,
          presente: presenca[matricula.id_cliente] !== undefined ? presenca[matricula.id_cliente] : true
        };
      });


      setAlunos(alunosCompletos);
    } catch (err) {
      console.error('❌ Erro ao carregar alunos:', err);
      setErroAlunos('Erro ao carregar alunos da turma. Verifique a conexão e tente novamente.');
    } finally {
      setLoadingAlunos(false);
    }
  };

  const handlePresencaChange = (idCliente, presente) => {
    setPresenca(prev => ({
      ...prev,
      [idCliente]: presente
    }));
  };

  const handleObservacaoChange = (idCliente, observacao) => {
    setObservacoes(prev => ({
      ...prev,
      [idCliente]: observacao
    }));
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  const salvarFrequencia = async () => {
    if (!turmaSelecionada || !dataSelecionada || alunos.length === 0) {
      return;
    }

    setSalvando(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');

      let response;
      
      // Se já existe registro, usar PUT para atualizar
      if (registroExistente) {
        
        // Usar o agendamentoId do registro existente para atualização
        const dadosFrequenciaUpdate = {
          st_codHashEmpresa: codHashEmpresa,
          codigoTurma: turmaSelecionada.codigoTurma,
          agendamentoId: registroExistente.agendamentoId, // Usar o agendamentoId existente
          data: dataSelecionada,
          alunos: alunos.map(aluno => ({
            id_cliente: aluno.id_cliente,
            id_matricula: aluno.id_matricula,
            presente: presenca[aluno.id_cliente] !== undefined ? presenca[aluno.id_cliente] : true,
            observacao: observacoes[aluno.id_cliente] || ''
          }))
        };
        
        // Usar o formato correto do endpoint PUT: /api/registrofrequencia/{agendamentoId}/data/{data}
        const putUrl = `/registrofrequencia/${registroExistente.agendamentoId}/data/${dataSelecionada}`;
        
        response = await api.put(putUrl, dadosFrequenciaUpdate);
      } else {
        // Se não existe, usar POST para criar novo
        
        // Criar dados para novo registro
        const dadosFrequencia = {
          st_codHashEmpresa: codHashEmpresa,
          codigoTurma: turmaSelecionada.codigoTurma,
          data: dataSelecionada,
          alunos: alunos.map(aluno => ({
            id_cliente: aluno.id_cliente,
            id_matricula: aluno.id_matricula,
            presente: presenca[aluno.id_cliente] !== undefined ? presenca[aluno.id_cliente] : true,
            observacao: observacoes[aluno.id_cliente] || ''
          }))
        };
        
        // Gerar um agendamentoId único baseado na turma e data
        const agendamentoId = `${turmaSelecionada.codigoTurma}-${dataSelecionada}-${Date.now()}`;
        dadosFrequencia.agendamentoId = agendamentoId;
        
        
        await api.post('/registrofrequencia', dadosFrequencia);
      }

      // Log de auditoria (Regra 10)
      const token = localStorage.getItem('token');
      const tokenPayload = JSON.parse(atob(token.split('.')[1]));
      const logData = {
        tipo_usuario: tokenPayload.perfil || "usuario",
        email: tokenPayload.email || "usuario@sistema.com",
        ip: env.CLIENT_IP,
        acao: registroExistente ? "ATUALIZACAO" : "CRIACAO",
        descricao: `${registroExistente ? 'Atualizou' : 'Registrou'} frequência da turma ${turmaSelecionada.codigoTurma} na data ${dataSelecionada}`,
        modulo: "registrofrequencia",
        metodo_http: registroExistente ? "PUT" : "POST",
        endpoint: registroExistente ? `/registrofrequencia/${registroExistente.agendamentoId}/data/${dataSelecionada}` : "/registrofrequencia",
        status_http: 200,
        userAgent: navigator.userAgent,
        sistema: "authsystem",
        st_codHashEmpresa: codHashEmpresa,
        transactionHash: codHashEmpresa
      };

      await api.post('/logs', logData);

      alert(registroExistente ? 'Frequência atualizada com sucesso!' : 'Frequência registrada com sucesso!');
      setOpenDialog(false);
    } catch (err) {
      console.error('❌ Erro completo:', err);
      console.error('❌ Status:', err.response?.status);
      console.error('❌ Data:', err.response?.data);
      console.error('❌ Headers:', err.response?.headers);
      
      const mensagemErro = err.response?.data?.details || err.response?.data?.error || err.message || 'Erro desconhecido';
      alert('Erro ao salvar frequência: ' + mensagemErro);
    } finally {
      setSalvando(false);
    }
  };

  const handleAbrirDialog = () => {
    setCardSelecionado('novo-registro');
    setOpenDialog(true);
    setTabValue(0);
    setTurmaSelecionada(null);
    setDataSelecionada('');
    setDatasValidas([]);
    setAlunos([]);
    setPresenca({});
    setObservacoes({});
    setRegistroExistente(null);
  };

  const handleCardClick = (cardType) => {
    setCardSelecionado(cardType);
    
    switch (cardType) {
      case 'novo-registro':
        handleAbrirDialog();
        break;
      case 'relatorio-turma':
        setOpenPorTurma(true);
        break;
      case 'relatorio-aluno':
        setOpenPorAluno(true);
        break;
      case 'estatisticas':
        setOpenEstatisticas(true);
        break;
      case 'historico':
        setOpenHistorico(true);
        break;
      case 'filtros':
        setOpenFiltros(true);
        break;
      case 'lista-chamada':
        setOpenListaChamada(true);
        break;
      case 'certificacao':
        setOpenCertificacao(true);
        break;
      case 'relatorio-detalhado':
        setOpenDetalhado(true);
        break;
      case 'relatorio-data':
        setOpenPorData(true);
        break;
      default:
        break;
    }
  };

  const carregarListaChamada = async () => {
    if (!turmaListaChamada || !dataInicio || !dataFim) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    // Validação das datas
    if (dataInicio > dataFim) {
      alert('A Data de Início deve ser menor ou igual à Data de Fim.');
      return;
    }

    setLoadingListaChamada(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      const url = `/registrofrequencia/relatorio/periodo?st_codHashEmpresa=${codHashEmpresa}&codigoTurma=${turmaListaChamada.codigoTurma}&dataInicio=${dataInicio}&dataFim=${dataFim}`;
      
      const response = await api.get(url);
      
      setDadosListaChamada(response.data || []);
      
      // Log de auditoria
      await criarLogAuth(
        "VISUALIZACAO",
        `Gerou lista de chamada para turma ${turmaListaChamada.codigoTurma} no período ${dataInicio} a ${dataFim}`,
        "GET",
        url
      );
      
    } catch (err) {
      console.error('❌ Erro ao carregar lista de chamada:', err);
      alert('Erro ao carregar dados da lista de chamada: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingListaChamada(false);
    }
  };

  const imprimirListaChamada = () => {
    if (dadosListaChamada.length === 0) {
      alert('Nenhum dado disponível para impressão.');
      return;
    }

    // Criar conteúdo da lista de chamada
    const conteudoListaChamada = gerarConteudoListaChamada();
    
    // Abrir nova janela com a lista de chamada
    const novaJanela = window.open('', '_blank', 'width=800,height=600');
    novaJanela.document.write(conteudoListaChamada);
    novaJanela.document.close();
  };

  // Função para criar logs de auditoria
  const criarLogAuth = async (acao, descricao, metodo_http, endpoint, status_http = 200) => {
    try {
      const token = localStorage.getItem("token");
      const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
      let tokenPayload = {};
      try {
        tokenPayload = JSON.parse(atob(token.split('.')[1]));
      } catch {
        tokenPayload = { perfil: "usuario", email: "usuario@sistema.com" };
      }
      const logData = {
        tipo_usuario: tokenPayload.perfil || "usuario",
        email: tokenPayload.email || "usuario@sistema.com",
        ip: env.CLIENT_IP,
        acao,
        descricao,
        modulo: "registrofrequencia",
        metodo_http,
        endpoint,
        status_http,
        userAgent: navigator.userAgent,
        sistema: "authsystem",
        st_codHashEmpresa: codHashEmpresa,
        transactionHash: codHashEmpresa
      };
      const headers = getHeaders();
      await api.post('/logs', logData, { headers });
    } catch (err) {
      // Não interrompe o fluxo principal se o log falhar
    }
  };

  const carregarRelatorioCertificacao = async () => {
    if (!turmaCertificacao) {
      alert('Por favor, selecione uma turma.');
      return;
    }

    setLoadingCertificacao(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      const url = `/registrofrequencia/relatorio/certificacao?st_codHashEmpresa=${codHashEmpresa}&codigoTurma=${turmaCertificacao.codigoTurma}&minPresenca=${minPresenca}`;
      
      const response = await api.get(url);
      
      setDadosCertificacao(response.data || []);
      
      // Log de auditoria
      await criarLogAuth(
        "VISUALIZACAO",
        `Gerou relatório de certificação para turma ${turmaCertificacao.codigoTurma} com ${minPresenca}% de presença mínima`,
        "GET",
        url
      );
      
    } catch (err) {
      console.error('❌ Erro ao carregar relatório de certificação:', err);
      alert('Erro ao carregar dados do relatório de certificação: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingCertificacao(false);
    }
  };

  const carregarRelatorioDetalhado = async () => {
    if (!turmaDetalhado || !dataInicioDetalhado || !dataFimDetalhado) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    // Converter datas formatadas para o formato da API
    const dataInicioAPI = converterDataParaAPI(dataInicioDetalhado);
    const dataFimAPI = converterDataParaAPI(dataFimDetalhado);

    // Validações de data da turma
    const { diaInicio, diaFim } = turmaDetalhado;
    
    if (diaInicio && dataInicioAPI < diaInicio) {
      alert(`A Data de Início deve ser maior ou igual à Data de Início da Turma (${formatarData(diaInicio)}).`);
      return;
    }
    
    if (diaFim && dataFimAPI > diaFim) {
      alert(`A Data de Término deve ser menor ou igual à Data de Término da Turma (${formatarData(diaFim)}).`);
      return;
    }

    // Validação adicional: data de início deve ser menor ou igual à data de fim
    if (dataInicioAPI > dataFimAPI) {
      alert('A Data de Início deve ser menor ou igual à Data de Término.');
      return;
    }

    setLoadingDetalhado(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      const url = `/registrofrequencia/relatorio/detalhado?st_codHashEmpresa=${codHashEmpresa}&codigoTurma=${turmaDetalhado.codigoTurma}&dataInicio=${dataInicioAPI}&dataFim=${dataFimAPI}`;
      
      const response = await api.get(url);
      
      setDadosDetalhado(response.data || {});
      
      // Log de auditoria
      await criarLogAuth(
        "VISUALIZACAO",
        `Gerou relatório detalhado para turma ${turmaDetalhado.codigoTurma} no período ${dataInicioAPI} a ${dataFimAPI}`,
        "GET",
        url
      );
      
    } catch (err) {
      console.error('❌ Erro ao carregar relatório detalhado:', err);
      alert('Erro ao carregar dados do relatório detalhado: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingDetalhado(false);
    }
  };


  const carregarRelatorioPorTurma = async () => {
    if (!turmaPorTurma) {
      alert('Por favor, selecione uma turma.');
      return;
    }

    setLoadingPorTurma(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      
      // Buscar relatório sintético da turma
      const url = `/registrofrequencia/relatorio/turma/${turmaPorTurma.codigoTurma}?st_codHashEmpresa=${codHashEmpresa}`;
      
      const response = await api.get(url);
      
      setDadosPorTurma(response.data || {});
      
      // Log de auditoria
      await criarLogAuth(
        "VISUALIZACAO",
        `Gerou relatório sintético de frequência para turma ${turmaPorTurma.nome || turmaPorTurma.codigoTurma}`,
        "GET",
        url
      );
      
    } catch (err) {
      console.error('❌ Erro ao carregar relatório por turma:', err);
      alert('Erro ao carregar dados do relatório por turma: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingPorTurma(false);
    }
  };

  const carregarRelatorioPorAluno = async () => {
    if (!alunoSelecionado) {
      alert('Por favor, selecione um aluno.');
      return;
    }

    setLoadingPorAluno(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      
      // Buscar todas as frequências do aluno em todas as turmas
      const url = `/registrofrequencia/aluno/${alunoSelecionado.id}?st_codHashEmpresa=${codHashEmpresa}`;
      
      const response = await api.get(url);
      
      setDadosPorAluno(response.data || []);
      
      // Log de auditoria
      await criarLogAuth(
        "VISUALIZACAO",
        `Gerou relatório completo de frequência para aluno ${alunoSelecionado.nome_completo || alunoSelecionado.nome || alunoSelecionado.id}`,
        "GET",
        url
      );
      
    } catch (err) {
      console.error('❌ Erro ao carregar relatório por aluno:', err);
      alert('Erro ao carregar dados do relatório por aluno: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingPorAluno(false);
    }
  };

  const carregarEstatisticas = async () => {
    setLoadingEstatisticas(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      const url = `/registrofrequencia/estatisticas?st_codHashEmpresa=${codHashEmpresa}`;
      
      const response = await api.get(url);
      
      setDadosEstatisticas(response.data || {});
      
      // Log de auditoria
      await criarLogAuth(
        "VISUALIZACAO",
        "Visualizou estatísticas gerais de frequência",
        "GET",
        url
      );
      
    } catch (err) {
      console.error('❌ Erro ao carregar estatísticas:', err);
      alert('Erro ao carregar estatísticas: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingEstatisticas(false);
    }
  };

  const carregarHistorico = async () => {
    if (!turmaHistorico) {
      alert('Por favor, selecione uma turma.');
      return;
    }

    setLoadingHistorico(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      const url = `/registrofrequencia/historico?st_codHashEmpresa=${codHashEmpresa}&codigoTurma=${turmaHistorico.codigoTurma}&periodo=${periodoHistorico}`;
      
      const response = await api.get(url);
      
      setDadosHistorico(response.data || {});
      
      // Log de auditoria
      await criarLogAuth(
        "VISUALIZACAO",
        `Visualizou histórico de frequência da turma ${turmaHistorico.codigoTurma} - ${periodoHistorico} dias`,
        "GET",
        url
      );
      
    } catch (err) {
      console.error('❌ Erro ao carregar histórico:', err);
      alert('Erro ao carregar histórico: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingHistorico(false);
    }
  };

  const aplicarFiltros = async () => {
    // Validação das datas
    if (filtrosConfig.dataInicio && filtrosConfig.dataFim && filtrosConfig.dataInicio > filtrosConfig.dataFim) {
      alert('A Data de Início deve ser menor ou igual à Data de Fim.');
      return;
    }

    setLoadingFiltros(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      const params = new URLSearchParams({
        st_codHashEmpresa: codHashEmpresa,
        statusPresenca: filtrosConfig.statusPresenca,
        frequenciaMinima: filtrosConfig.frequenciaMinima,
        frequenciaMaxima: filtrosConfig.frequenciaMaxima
      });

      if (filtrosConfig.turma) {
        params.append('codigoTurma', filtrosConfig.turma.codigoTurma);
      }
      if (filtrosConfig.aluno) {
        params.append('idAluno', filtrosConfig.aluno.id);
      }
      if (filtrosConfig.dataInicio) {
        params.append('dataInicio', filtrosConfig.dataInicio);
      }
      if (filtrosConfig.dataFim) {
        params.append('dataFim', filtrosConfig.dataFim);
      }

      const url = `/registrofrequencia/filtros?${params.toString()}`;
      
      const response = await api.get(url);
      
      setResultadosFiltros(response.data || []);
      
      // Log de auditoria
      await criarLogAuth(
        "VISUALIZACAO",
        "Aplicou filtros avançados de frequência",
        "GET",
        url
      );
      
    } catch (err) {
      console.error('❌ Erro ao aplicar filtros:', err);
      alert('Erro ao aplicar filtros: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingFiltros(false);
    }
  };

  const carregarRelatorioPorData = async () => {
    if (!turmaPorData) {
      alert('Por favor, selecione uma turma.');
      return;
    }

    setLoadingPorData(true);
    try {
      const codHashEmpresa = localStorage.getItem('st_codHashEmpresa');
      const url = `/registrofrequencia/por-data?st_codHashEmpresa=${codHashEmpresa}&codigoTurma=${turmaPorData.codigoTurma}`;
      
      const response = await api.get(url);
      
      setDadosPorData(response.data || {});
      
      // Log de auditoria
      await criarLogAuth(
        "VISUALIZACAO",
        `Gerou relatório por data para turma ${turmaPorData.codigoTurma}`,
        "GET",
        url
      );
      
    } catch (err) {
      console.error('❌ Erro ao carregar relatório por data:', err);
      alert('Erro ao carregar dados do relatório por data: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingPorData(false);
    }
  };

  const imprimirRelatorioCertificacao = () => {
    if (dadosCertificacao.length === 0) {
      alert('Nenhum dado disponível para impressão.');
      return;
    }

    // Criar conteúdo do relatório de certificação
    const conteudoCertificacao = gerarConteudoCertificacao();
    
    // Abrir nova janela com o relatório
    const novaJanela = window.open('', '_blank', 'width=800,height=600');
    novaJanela.document.write(conteudoCertificacao);
    novaJanela.document.close();
  };

  const imprimirRelatorioDetalhado = () => {
    if (Object.keys(dadosDetalhado).length === 0) {
      alert('Nenhum dado disponível para impressão.');
      return;
    }

    const conteudoDetalhado = gerarConteudoDetalhado();
    const novaJanela = window.open('', '_blank', 'width=800,height=600');
    novaJanela.document.write(conteudoDetalhado);
    novaJanela.document.close();
  };

  const imprimirRelatorioPorTurma = () => {
    if (Object.keys(dadosPorTurma).length === 0) {
      alert('Nenhum dado disponível para impressão.');
      return;
    }

    const conteudoPorTurma = gerarConteudoPorTurma();
    const novaJanela = window.open('', '_blank', 'width=800,height=600');
    novaJanela.document.write(conteudoPorTurma);
    novaJanela.document.close();
  };

  const imprimirRelatorioPorAluno = () => {
    if (dadosPorAluno.length === 0) {
      alert('Nenhum dado disponível para impressão.');
      return;
    }

    const conteudoPorAluno = gerarConteudoPorAluno();
    const novaJanela = window.open('', '_blank', 'width=800,height=600');
    novaJanela.document.write(conteudoPorAluno);
    novaJanela.document.close();
  };

  const imprimirRelatorioPorData = () => {
    if (Object.keys(dadosPorData).length === 0) {
      alert('Nenhum dado disponível para impressão.');
      return;
    }

    const conteudoPorData = gerarConteudoPorData();
    const novaJanela = window.open('', '_blank', 'width=800,height=600');
    novaJanela.document.write(conteudoPorData);
    novaJanela.document.close();
  };

  const gerarConteudoPorTurma = () => {
    const turma = turmaPorTurma;
    const dataGeracao = formatarData(new Date());
    
    // Calcular estatísticas gerais da turma
    const totalAlunos = dadosPorTurma.totalAlunos || 0;
    const totalAulas = dadosPorTurma.totalAulas || 0;
    const totalPresencas = dadosPorTurma.totalPresencas || 0;
    const totalFaltas = dadosPorTurma.totalFaltas || 0;
    const frequenciaGeral = totalAulas > 0 ? ((totalPresencas / totalAulas) * 100) : 0;
    
    // Organizar dados por aluno
    const alunos = dadosPorTurma.alunos || [];
    
    let tabelaHTML = '';
    if (alunos.length > 0) {
      tabelaHTML = `
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <thead>
            <tr style="background-color: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Nº</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Nome do Aluno</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Total Aulas</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Presenças</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Faltas</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Frequência</th>
            </tr>
          </thead>
          <tbody>
      `;
      
      alunos.forEach((aluno, index) => {
        const frequencia = aluno.totalAulas > 0 ? ((aluno.presencas / aluno.totalAulas) * 100) : 0;
        const frequenciaClass = parseFloat(frequencia) >= 75 ? 'aprovado' : 'reprovado';
        
        tabelaHTML += `
          <tr>
            <td style="border: 1px solid #ddd; padding: 8px;">${index + 1}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${aluno.nome || `Aluno ${aluno.id}`}</td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${aluno.totalAulas}</td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center; color: #2e7d32; font-weight: bold;">${aluno.presencas}</td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center; color: #d32f2f; font-weight: bold;">${aluno.faltas}</td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center;" class="${frequenciaClass}">${formatarPercentual(frequencia)}</td>
          </tr>
        `;
      });
      
      tabelaHTML += `
          </tbody>
        </table>
      `;
    }

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Relatório Sintético por Turma - ${turma?.nome || turma?.codigoTurma}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; line-height: 1.4; color: #333; }
          .header { text-align: center; margin-bottom: 20px; border-bottom: 2px solid #333; padding-bottom: 10px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background-color: #f5f5f5; font-weight: bold; }
          .aprovado { background-color: #e8f5e8; color: #2e7d32; font-weight: bold; }
          .reprovado { background-color: #ffebee; color: #d32f2f; font-weight: bold; }
          .stats-box { background-color: #e3f2fd; padding: 15px; margin: 20px 0; border-radius: 8px; border-left: 4px solid #1976d2; }
          @media print { body { margin: 10px; } .no-print { display: none; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>Relatório Sintético de Frequência por Turma</h1>
          <h2>${turma?.nome || turma?.codigoTurma}</h2>
          <p><strong>Código da Turma:</strong> ${turma?.codigoTurma || 'N/A'}</p>
          <p><strong>Data de Geração:</strong> ${dataGeracao}</p>
        </div>
        
        <div class="stats-box">
          <h3 style="margin: 0 0 10px 0; color: #1976d2;">📊 Estatísticas Gerais da Turma</h3>
          <p style="margin: 5px 0;"><strong>Total de Alunos:</strong> ${totalAlunos}</p>
          <p style="margin: 5px 0;"><strong>Total de Aulas:</strong> ${totalAulas}</p>
          <p style="margin: 5px 0;"><strong>Total de Presenças:</strong> ${totalPresencas}</p>
          <p style="margin: 5px 0;"><strong>Total de Faltas:</strong> ${totalFaltas}</p>
          <p style="margin: 5px 0;"><strong>Frequência Geral da Turma:</strong> <span style="color: #1976d2; font-weight: bold;">${formatarPercentual(frequenciaGeral)}</span></p>
        </div>
        
        ${tabelaHTML}
        
        <div class="no-print" style="text-align: center; margin-top: 30px;">
          <button onclick="window.print()">🖨️ Imprimir</button>
          <button onclick="window.close()">❌ Fechar</button>
        </div>
      </body>
      </html>
    `;
  };

  const gerarConteudoDetalhado = () => {
    const turma = turmaDetalhado;
    const periodo = `${dataInicioDetalhadoFormatada} a ${dataFimDetalhadoFormatada}`;
    const dataGeracao = formatarData(new Date());
    
    // Organizar dados por data
    const datas = Object.keys(dadosDetalhado).sort();
    
    let tabelaHTML = '';
    datas.forEach(data => {
      const alunos = dadosDetalhado[data];
      const dataFormatada = formatarData(data);
      
      tabelaHTML += `
        <div style="page-break-after: always; margin-bottom: 20px;">
          <h3 style="text-align: center; margin-bottom: 10px;">Relatório Detalhado - ${dataFormatada}</h3>
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Nº</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Nome do Aluno</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Status</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Observações</th>
              </tr>
            </thead>
            <tbody>
      `;
      
      alunos.forEach((aluno, index) => {
        const status = aluno.presente ? 'Presente' : 'Faltou';
        const statusClass = aluno.presente ? 'aprovado' : 'reprovado';
        
        tabelaHTML += `
          <tr>
            <td style="border: 1px solid #ddd; padding: 8px;">${index + 1}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${aluno.nome || `Aluno ${aluno.id_cliente}`}</td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center;" class="${statusClass}">${status}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${aluno.observacao || ''}</td>
          </tr>
        `;
      });
      
      tabelaHTML += `
            </tbody>
          </table>
          <div style="margin-top: 20px;">
            <p><strong>Total de Alunos:</strong> ${alunos.length}</p>
            <p><strong>Presentes:</strong> ${alunos.filter(a => a.presente).length}</p>
            <p><strong>Faltas:</strong> ${alunos.filter(a => !a.presente).length}</p>
          </div>
        </div>
      `;
    });

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Relatório Detalhado - ${turma?.nome || turma?.codigoTurma}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; line-height: 1.4; color: #333; }
          .header { text-align: center; margin-bottom: 20px; border-bottom: 2px solid #333; padding-bottom: 10px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background-color: #f5f5f5; font-weight: bold; }
          .aprovado { background-color: #e8f5e8; color: #2e7d32; font-weight: bold; }
          .reprovado { background-color: #ffebee; color: #d32f2f; font-weight: bold; }
          @media print { body { margin: 10px; } .no-print { display: none; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>Relatório Detalhado de Frequência</h1>
          <h2>${turma?.nome || turma?.codigoTurma}</h2>
          <p><strong>Período:</strong> ${periodo}</p>
          <p><strong>Data de Geração:</strong> ${dataGeracao}</p>
        </div>
        
        ${tabelaHTML}
        
        <div class="no-print" style="text-align: center; margin-top: 30px;">
          <button onclick="window.print()">🖨️ Imprimir</button>
          <button onclick="window.close()">❌ Fechar</button>
        </div>
      </body>
      </html>
    `;
  };

  const gerarConteudoPorAluno = () => {
    const aluno = alunoSelecionado;
    const dataGeracao = formatarData(new Date());
    
    // Organizar dados por turma
    const dadosPorTurma = {};
    dadosPorAluno.forEach(registro => {
      if (!dadosPorTurma[registro.codigoTurma]) {
        dadosPorTurma[registro.codigoTurma] = [];
      }
      dadosPorTurma[registro.codigoTurma].push(registro);
    });

    // Calcular estatísticas gerais
    const totalAulas = dadosPorAluno.length;
    const totalPresencas = dadosPorAluno.filter(r => r.presente).length;
    const totalFaltas = dadosPorAluno.filter(r => !r.presente).length;
    const frequenciaGeral = totalAulas > 0 ? ((totalPresencas / totalAulas) * 100) : 0;

    let tabelaHTML = '';
    Object.keys(dadosPorTurma).forEach(codigoTurma => {
      const registros = dadosPorTurma[codigoTurma];
      const presencasTurma = registros.filter(r => r.presente).length;
      const faltasTurma = registros.filter(r => !r.presente).length;
      const frequenciaTurma = registros.length > 0 ? ((presencasTurma / registros.length) * 100) : 0;
      
      tabelaHTML += `
        <div style="page-break-after: always; margin-bottom: 20px;">
          <h3 style="text-align: center; margin-bottom: 10px;">Turma: ${codigoTurma}</h3>
          <div style="background-color: #f8f9fa; padding: 10px; margin-bottom: 15px; border-radius: 5px;">
            <p><strong>Resumo da Turma:</strong></p>
            <p>• Total de Aulas: ${registros.length}</p>
            <p>• Presenças: ${presencasTurma} (${formatarPercentual(frequenciaTurma)})</p>
            <p>• Faltas: ${faltasTurma}</p>
          </div>
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Data</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Status</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Observações</th>
              </tr>
            </thead>
            <tbody>
      `;
      
      // Ordenar registros por data
      const registrosOrdenados = registros.sort((a, b) => new Date(a.data) - new Date(b.data));
      
      registrosOrdenados.forEach(registro => {
        const dataFormatada = formatarData(registro.data);
        const status = registro.presente ? 'Presente' : 'Faltou';
        const statusClass = registro.presente ? 'aprovado' : 'reprovado';
        
        tabelaHTML += `
          <tr>
            <td style="border: 1px solid #ddd; padding: 8px;">${dataFormatada}</td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center;" class="${statusClass}">${status}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${registro.observacao || ''}</td>
          </tr>
        `;
      });
      
      tabelaHTML += `
            </tbody>
          </table>
        </div>
      `;
    });

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Relatório de Frequência - ${aluno?.nome || aluno?.id}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; line-height: 1.4; color: #333; }
          .header { text-align: center; margin-bottom: 20px; border-bottom: 2px solid #333; padding-bottom: 10px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background-color: #f5f5f5; font-weight: bold; }
          .aprovado { background-color: #e8f5e8; color: #2e7d32; font-weight: bold; }
          .reprovado { background-color: #ffebee; color: #d32f2f; font-weight: bold; }
          @media print { body { margin: 10px; } .no-print { display: none; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>Relatório de Frequência por Aluno</h1>
          <h2>${aluno?.nome_completo || aluno?.nome || `Aluno ${aluno?.id}`}</h2>
          <p><strong>CPF:</strong> ${aluno?.cpf_cnpj ? formatarCPF(aluno.cpf_cnpj) : 'N/A'}</p>
          <p><strong>Data de Geração:</strong> ${dataGeracao}</p>
          <div style="background-color: #e8f5e8; padding: 15px; margin: 20px 0; border-radius: 8px; border-left: 4px solid #4caf50;">
            <h3 style="margin: 0 0 10px 0; color: #2e7d32;">📊 Estatísticas Gerais</h3>
            <p style="margin: 5px 0;"><strong>Total de Aulas:</strong> ${totalAulas}</p>
            <p style="margin: 5px 0;"><strong>Total de Presenças:</strong> ${totalPresencas}</p>
            <p style="margin: 5px 0;"><strong>Total de Faltas:</strong> ${totalFaltas}</p>
            <p style="margin: 5px 0;"><strong>Frequência Geral:</strong> <span style="color: #2e7d32; font-weight: bold;">${formatarPercentual(frequenciaGeral)}</span></p>
          </div>
        </div>
        
        ${tabelaHTML}
        
        <div class="no-print" style="text-align: center; margin-top: 30px;">
          <button onclick="window.print()">🖨️ Imprimir</button>
          <button onclick="window.close()">❌ Fechar</button>
        </div>
      </body>
      </html>
    `;
  };

  const gerarConteudoPorData = () => {
    const turma = turmaPorData;
    const dataGeracao = formatarData(new Date());
    
    // Organizar dados por data
    const datas = Object.keys(dadosPorData).sort();
    
    let tabelaHTML = '';
    datas.forEach(data => {
      const alunos = dadosPorData[data];
      const dataFormatada = formatarData(data);
      
      tabelaHTML += `
        <div style="page-break-after: always; margin-bottom: 20px;">
          <h3 style="text-align: center; margin-bottom: 10px;">Frequência por Data - ${dataFormatada}</h3>
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Nº</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Nome do Aluno</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Status</th>
              </tr>
            </thead>
            <tbody>
      `;
      
      alunos.forEach((aluno, index) => {
        const status = aluno.presente ? 'Presente' : 'Faltou';
        const statusClass = aluno.presente ? 'aprovado' : 'reprovado';
        
        // Buscar nome do cliente
        const cliente = clientes.find(c => c.id === aluno.id_cliente);
        const nomeAluno = cliente ? (cliente.nome_completo || cliente.nome || cliente.st_nome || `Aluno ${aluno.id_cliente}`) : `Aluno ${aluno.id_cliente}`;
        
        tabelaHTML += `
          <tr>
            <td style="border: 1px solid #ddd; padding: 8px;">${index + 1}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${nomeAluno}</td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center;" class="${statusClass}">${status}</td>
          </tr>
        `;
      });
      
      tabelaHTML += `
            </tbody>
          </table>
          <div style="margin-top: 20px;">
            <p><strong>Total de Alunos:</strong> ${alunos.length}</p>
            <p><strong>Presentes:</strong> ${alunos.filter(a => a.presente).length}</p>
            <p><strong>Faltas:</strong> ${alunos.filter(a => !a.presente).length}</p>
          </div>
        </div>
      `;
    });

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Relatório por Data - ${turma?.nome || turma?.codigoTurma}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; line-height: 1.4; color: #333; }
          .header { text-align: center; margin-bottom: 20px; border-bottom: 2px solid #333; padding-bottom: 10px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background-color: #f5f5f5; font-weight: bold; }
          .aprovado { background-color: #e8f5e8; color: #2e7d32; font-weight: bold; }
          .reprovado { background-color: #ffebee; color: #d32f2f; font-weight: bold; }
          @media print { body { margin: 10px; } .no-print { display: none; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>Relatório de Frequência por Data</h1>
          <h2>${turma?.nome || turma?.codigoTurma}</h2>
          <p><strong>Data de Geração:</strong> ${dataGeracao}</p>
        </div>
        
        ${tabelaHTML}
        
        <div class="no-print" style="text-align: center; margin-top: 30px;">
          <button onclick="window.print()">🖨️ Imprimir</button>
          <button onclick="window.close()">❌ Fechar</button>
        </div>
      </body>
      </html>
    `;
  };

  const gerarConteudoCertificacao = () => {
    const turma = turmaCertificacao;
    const dataGeracao = formatarData(new Date());
    
    // Separar alunos aprovados e reprovados
    const alunosAprovados = dadosCertificacao.filter(aluno => aluno.aprovado);
    const alunosReprovados = dadosCertificacao.filter(aluno => !aluno.aprovado);
    
    // Calcular estatísticas
    const totalAlunos = dadosCertificacao.length;
    const totalAprovados = alunosAprovados.length;
    const totalReprovados = alunosReprovados.length;
    const percentualAprovacao = totalAlunos > 0 ? ((totalAprovados / totalAlunos) * 100) : 0;

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Relatório de Certificação - ${turma?.nome || turma?.codigoTurma}</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
            line-height: 1.4;
            color: #333;
          }
          .header {
            text-align: center;
            margin-bottom: 20px;
            border-bottom: 2px solid #333;
            padding-bottom: 10px;
          }
          .summary {
            background-color: #f9f9f9;
            padding: 15px;
            border-radius: 5px;
            margin-bottom: 20px;
            border-left: 4px solid #4caf50;
          }
          .stats {
            display: flex;
            justify-content: space-around;
            margin: 20px 0;
            text-align: center;
          }
          .stat-box {
            background-color: #e8f5e8;
            padding: 15px;
            border-radius: 5px;
            border: 1px solid #4caf50;
            min-width: 120px;
          }
          .stat-number {
            font-size: 24px;
            font-weight: bold;
            color: #2e7d32;
          }
          .stat-label {
            font-size: 12px;
            color: #666;
            margin-top: 5px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
          }
          th, td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
          }
          th {
            background-color: #f5f5f5;
            font-weight: bold;
          }
          .aprovado {
            background-color: #e8f5e8;
            color: #2e7d32;
            font-weight: bold;
          }
          .reprovado {
            background-color: #ffebee;
            color: #d32f2f;
            font-weight: bold;
          }
          .section {
            margin-bottom: 30px;
            page-break-inside: avoid;
          }
          .section-title {
            background-color: #2196f3;
            color: white;
            padding: 10px;
            border-radius: 5px;
            margin-bottom: 15px;
          }
          @media print {
            body { margin: 10px; }
            .no-print { display: none; }
            .section { page-break-inside: avoid; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>Relatório de Certificação</h1>
          <h2>${turma?.nome || turma?.codigoTurma}</h2>
          <p><strong>Frequência Mínima Exigida:</strong> ${formatarPercentual(minPresenca)}</p>
          <p><strong>Data de Geração:</strong> ${dataGeracao}</p>
        </div>

        <div class="summary">
          <h3>📊 Resumo Geral</h3>
          <p>Este relatório apresenta a análise de frequência dos alunos para fins de certificação, considerando a frequência mínima de ${minPresenca}%.</p>
        </div>

        <div class="stats">
          <div class="stat-box">
            <div class="stat-number">${totalAlunos}</div>
            <div class="stat-label">Total de Alunos</div>
          </div>
          <div class="stat-box">
            <div class="stat-number">${totalAprovados}</div>
            <div class="stat-label">Aprovados</div>
          </div>
          <div class="stat-box">
            <div class="stat-number">${totalReprovados}</div>
            <div class="stat-label">Reprovados</div>
          </div>
          <div class="stat-box">
            <div class="stat-number">${formatarPercentual(percentualAprovacao)}</div>
            <div class="stat-label">Taxa de Aprovação</div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">
            ✅ Alunos Aprovados para Certificação (${alunosAprovados.length})
          </div>
          ${alunosAprovados.length > 0 ? `
            <table>
              <thead>
                <tr>
                  <th>Nº</th>
                  <th>Nome do Aluno</th>
                  <th>Frequência (%)</th>
                  <th>Total de Aulas</th>
                  <th>Presenças</th>
                  <th>Faltas</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                ${alunosAprovados.map((aluno, index) => `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${aluno.nome || `Aluno ${aluno.id_cliente}`}</td>
                    <td>${aluno.frequencia_percentual || 0}%</td>
                    <td>${aluno.total_aulas || 0}</td>
                    <td>${aluno.presencas || 0}</td>
                    <td>${aluno.faltas || 0}</td>
                    <td class="aprovado">APROVADO</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          ` : '<p>Nenhum aluno aprovado encontrado.</p>'}
        </div>

        ${alunosReprovados.length > 0 ? `
          <div class="section">
            <div class="section-title">
              ❌ Alunos Reprovados por Frequência (${alunosReprovados.length})
            </div>
            <table>
              <thead>
                <tr>
                  <th>Nº</th>
                  <th>Nome do Aluno</th>
                  <th>Frequência (%)</th>
                  <th>Total de Aulas</th>
                  <th>Presenças</th>
                  <th>Faltas</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                ${alunosReprovados.map((aluno, index) => `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${aluno.nome || `Aluno ${aluno.id_cliente}`}</td>
                    <td>${aluno.frequencia_percentual || 0}%</td>
                    <td>${aluno.total_aulas || 0}</td>
                    <td>${aluno.presencas || 0}</td>
                    <td>${aluno.faltas || 0}</td>
                    <td class="reprovado">REPROVADO</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        ` : ''}

        <div class="section">
          <div class="section-title">
            📋 Observações e Recomendações
          </div>
          <ul>
            <li><strong>Frequência Mínima:</strong> ${formatarPercentual(minPresenca)} para aprovação</li>
            <li><strong>Alunos Aprovados:</strong> ${totalAprovados} de ${totalAlunos} (${formatarPercentual(percentualAprovacao)})</li>
            <li><strong>Alunos Reprovados:</strong> ${totalReprovados} de ${totalAlunos} (${formatarPercentual(100 - percentualAprovacao)})</li>
            ${totalReprovados > 0 ? `<li><strong>Ação Recomendada:</strong> Entrar em contato com os alunos reprovados para orientação sobre recuperação de frequência</li>` : ''}
            <li><strong>Validade:</strong> Este relatório foi gerado em ${dataGeracao} e reflete a situação atual dos registros de frequência</li>
          </ul>
        </div>

        <div class="no-print" style="text-align: center; margin-top: 30px;">
          <button onclick="window.print()">🖨️ Imprimir</button>
          <button onclick="window.close()">❌ Fechar</button>
        </div>
      </body>
      </html>
    `;
  };

  const gerarConteudoListaChamada = () => {
    const turma = turmaListaChamada;
    const periodo = `${formatarData(dataInicio)} a ${formatarData(dataFim)}`;
    const dataGeracao = formatarData(new Date());
    
    // Calcular datas do período selecionado
    const dataInicioObj = new Date(dataInicio);
    const dataFimObj = new Date(dataFim);
    const datasOrdenadas = [];
    
    for (let d = new Date(dataInicioObj); d <= dataFimObj; d.setDate(d.getDate() + 1)) {
      datasOrdenadas.push(new Date(d).toISOString().split('T')[0]);
    }
    
    // Buscar alunos da turma
    const alunosArray = [];
    if (turma && turma.alunos) {
      turma.alunos.forEach((aluno, index) => {
        alunosArray.push({
          id: aluno.id || index + 1,
          nome: aluno.nome || aluno.nome_completo || `Aluno ${index + 1}`
        });
      });
    }
    
    // Se não houver alunos na turma, criar espaços em branco
    if (alunosArray.length === 0) {
      for (let i = 1; i <= 30; i++) {
        alunosArray.push({
          id: i,
          nome: `Aluno ${i}`
        });
      }
    }
    
    // Gerar cabeçalho com informações completas do curso
    const headerHTML = `
      <div class="header">
        <h1>📋 Lista de Chamada</h1>
        <h2>${turma?.nome || 'Turma'}</h2>
        <div class="course-info">
          <p><strong>Código da Turma:</strong> ${turma?.codigoTurma || 'N/A'}</p>
          <p><strong>Período do Curso:</strong> ${turma?.diaInicio ? formatarData(turma.diaInicio) : 'N/A'} a ${turma?.diaFim ? formatarData(turma.diaFim) : 'N/A'}</p>
          <p><strong>Período da Lista:</strong> ${periodo}</p>
          <p><strong>Data de Geração:</strong> ${dataGeracao}</p>
          <p><strong>Total de Alunos:</strong> ${alunosArray.length}</p>
          <p><strong>Total de Aulas:</strong> ${datasOrdenadas.length}</p>
        </div>
      </div>
    `;

    // Gerar tabela em branco com quadradinhos
    let tabelaHTML = `
      <table class="attendance-table">
        <thead>
          <tr>
            <th class="student-header">Nome do Aluno</th>
    `;
    
    // Adicionar cabeçalhos dos dias (vertical)
    datasOrdenadas.forEach(data => {
      const dataObj = new Date(data);
      const diaSemana = dataObj.toLocaleDateString('pt-BR', { weekday: 'short' });
      
      tabelaHTML += `
        <th class="date-header">
          <div class="date-vertical">
            <div class="date-day">${dataObj.getDate()}</div>
            <div class="date-month">${dataObj.toLocaleDateString('pt-BR', { month: 'short' })}</div>
            <div class="date-weekday">${diaSemana}</div>
          </div>
        </th>
      `;
    });
    
    tabelaHTML += `
          </tr>
        </thead>
        <tbody>
    `;
    
    // Adicionar linhas dos alunos com quadradinhos em branco
    alunosArray.forEach((aluno, index) => {
      tabelaHTML += `
        <tr>
          <td class="student-name">${index + 1}. ${aluno.nome}</td>
      `;
      
      // Adicionar quadradinhos em branco para cada dia
      datasOrdenadas.forEach(data => {
        tabelaHTML += `<td class="empty-cell"></td>`;
      });
      
      tabelaHTML += `</tr>`;
    });
    
    // Adicionar linhas extras em branco se necessário
    const linhasExtras = Math.max(0, 30 - alunosArray.length);
    for (let i = 0; i < linhasExtras; i++) {
      tabelaHTML += `
        <tr>
          <td class="student-name">${alunosArray.length + i + 1}.</td>
      `;
      
      // Usar for loop em vez de forEach para evitar função em loop
      for (let j = 0; j < datasOrdenadas.length; j++) {
        tabelaHTML += `<td class="empty-cell"></td>`;
      }
      
      tabelaHTML += `</tr>`;
    }
    
    tabelaHTML += `
        </tbody>
      </table>
    `;

    // Gerar legenda para preenchimento manual
    const legendaHTML = `
      <div class="legend">
        <h3>📝 Instruções para Preenchimento</h3>
        <div class="legend-items">
          <div class="legend-item">
            <span class="legend-symbol present">✓</span>
            <span>Presente - Marque com ✓</span>
          </div>
          <div class="legend-item">
            <span class="legend-symbol absent">✗</span>
            <span>Faltou - Marque com ✗</span>
          </div>
          <div class="legend-item">
            <span class="legend-symbol absence">-</span>
            <span>Sem aula - Deixe em branco</span>
          </div>
        </div>
        <p style="margin-top: 15px; font-size: 11px; color: #666;">
          <strong>Observações:</strong> Use o espaço abaixo da tabela para anotações sobre ausências justificadas, 
          atrasos ou outras observações importantes sobre a frequência dos alunos.
        </p>
      </div>
    `;

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Lista de Chamada - ${turma?.nome || turma?.codigoTurma}</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
            line-height: 1.4;
            color: #333;
            font-size: 12px;
          }
          .header {
            text-align: center;
            margin-bottom: 20px;
            border-bottom: 2px solid #333;
            padding-bottom: 15px;
          }
          .header h1 {
            margin: 0 0 10px 0;
            font-size: 24px;
            color: #1976d2;
          }
          .header h2 {
            margin: 0 0 15px 0;
            font-size: 20px;
            color: #333;
          }
          .course-info {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 10px;
            text-align: left;
            margin-top: 15px;
            padding: 15px;
            background-color: #f5f5f5;
            border-radius: 8px;
          }
          .course-info p {
            margin: 5px 0;
            font-size: 11px;
          }
          .attendance-table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
            page-break-inside: avoid;
          }
          .attendance-table th,
          .attendance-table td {
            border: 1px solid #ddd;
            padding: 6px;
            text-align: center;
            vertical-align: middle;
            font-size: 11px;
          }
          .student-header {
            background-color: #1976d2;
            color: white;
            font-weight: bold;
            text-align: left;
            min-width: 200px;
            max-width: 200px;
          }
          .date-header {
            background-color: #f5f5f5;
            font-weight: bold;
            min-width: 40px;
            max-width: 40px;
            height: 80px;
            vertical-align: bottom;
          }
          .date-vertical {
            writing-mode: vertical-rl;
            text-orientation: mixed;
            transform: rotate(180deg);
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .date-day {
            font-size: 14px;
            font-weight: bold;
            color: #1976d2;
          }
          .date-month {
            font-size: 10px;
            color: #666;
          }
          .date-weekday {
            font-size: 9px;
            color: #999;
          }
          .student-name {
            background-color: #f9f9f9;
            font-weight: bold;
            text-align: left;
            padding-left: 10px;
            min-width: 200px;
            max-width: 200px;
          }
          .empty-cell {
            min-width: 35px;
            max-width: 35px;
            height: 25px;
            border: 1px solid #ccc;
            background-color: white;
            cursor: text;
            position: relative;
          }
          .empty-cell:hover {
            background-color: #f9f9f9;
          }
          .attendance-cell {
            font-size: 16px;
            font-weight: bold;
            min-width: 40px;
            max-width: 40px;
            height: 30px;
          }
          .present {
            background-color: #e8f5e8;
            color: #2e7d32;
          }
          .absent {
            background-color: #ffebee;
            color: #d32f2f;
          }
          .absence {
            background-color: #f5f5f5;
            color: #999;
          }
          .legend {
            margin-top: 20px;
            padding: 15px;
            background-color: #f9f9f9;
            border-radius: 8px;
            border: 1px solid #ddd;
          }
          .legend h3 {
            margin: 0 0 10px 0;
            font-size: 14px;
            color: #333;
          }
          .legend-items {
            display: flex;
            gap: 20px;
            flex-wrap: wrap;
          }
          .legend-item {
            display: flex;
            align-items: center;
            gap: 5px;
            font-size: 11px;
          }
          .legend-symbol {
            font-size: 16px;
            font-weight: bold;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 3px;
          }
          .legend-symbol.present {
            background-color: #e8f5e8;
            color: #2e7d32;
          }
          .legend-symbol.absent {
            background-color: #ffebee;
            color: #d32f2f;
          }
          .legend-symbol.absence {
            background-color: #f5f5f5;
            color: #999;
          }
          .observations-section {
            margin-top: 30px;
            padding: 20px;
            background-color: #f9f9f9;
            border-radius: 8px;
            border: 1px solid #ddd;
          }
          .observations-section h3 {
            margin: 0 0 15px 0;
            font-size: 14px;
            color: #333;
          }
          .observations-grid {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .observation-line {
            display: flex;
            align-items: center;
            gap: 10px;
          }
          .observation-label {
            font-size: 11px;
            font-weight: bold;
            color: #333;
            min-width: 20px;
          }
          .observation-box {
            flex: 1;
            height: 20px;
            border: 1px solid #ccc;
            background-color: white;
            border-radius: 3px;
          }
          @media print {
            body { 
              margin: 10px; 
              font-size: 10px;
            }
            .no-print { display: none; }
            .attendance-table {
              page-break-inside: avoid;
            }
            .header {
              page-break-after: avoid;
            }
            .legend {
              page-break-before: avoid;
            }
          }
        </style>
      </head>
      <body>
        ${headerHTML}
        
        ${tabelaHTML}
        
        <!-- Seção de Observações -->
        <div class="observations-section">
          <h3>📝 Observações</h3>
          <div class="observations-grid">
            <div class="observation-line">
              <span class="observation-label">1.</span>
              <div class="observation-box"></div>
            </div>
            <div class="observation-line">
              <span class="observation-label">2.</span>
              <div class="observation-box"></div>
            </div>
            <div class="observation-line">
              <span class="observation-label">3.</span>
              <div class="observation-box"></div>
            </div>
            <div class="observation-line">
              <span class="observation-label">4.</span>
              <div class="observation-box"></div>
            </div>
            <div class="observation-line">
              <span class="observation-label">5.</span>
              <div class="observation-box"></div>
            </div>
          </div>
        </div>
        
        ${legendaHTML}
        
        <div class="no-print" style="text-align: center; margin-top: 30px;">
          <button onclick="window.print()" style="padding: 10px 20px; margin: 0 10px; font-size: 14px; cursor: pointer;">🖨️ Imprimir</button>
          <button onclick="window.close()" style="padding: 10px 20px; margin: 0 10px; font-size: 14px; cursor: pointer;">❌ Fechar</button>
        </div>
      </body>
      </html>
    `;
  };

  if (!acessoPermitido) {
    return <AcessoRestrito />;
  }

  return (
    <AcessoRestrito modulo="registrofrequencia">
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
      {/* Box interno com margens de 1,5% */}
      <Box sx={{
        margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
        height: '90vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box sx={{ 
          p: { xs: 2, sm: 3 }, 
          pb: 2,
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: { xs: 'flex-start', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 2, sm: 0 }
        }}>
          <Typography 
            variant="h5" 
            mb={1} 
            sx={{ 
              fontSize: { xs: '1.5rem', sm: '2rem' },
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <AccessTimeIcon sx={{ 
              fontSize: { xs: '1.5rem', sm: '2rem' },
              color: '#FFC107' // Mesma cor usada no menu lateral
            }} />
            Registro de Frequência
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Sistema completo de controle de frequência escolar
          </Typography>
        </Box>

        {/* Grid de Cards de Funcionalidades */}
        <Grid container spacing={3} sx={{ flex: 1, overflow: 'auto' }}>
        {/* Card - Novo Registro */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: (theme) => theme.palette.mode === 'dark' 
                ? '0 2px 8px rgba(0, 0, 0, 0.15)' 
                : '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRadius: 2,
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? 'rgba(255, 255, 255, 0.08)' 
                  : 'rgba(0, 0, 0, 0.04)'
              }
            }}
            onClick={() => handleCardClick('novo-registro')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Save sx={{ 
                fontSize: 60, 
                color: '#FFC107', 
                mb: 2,
                display: 'block',
                mx: 'auto'
              }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Novo Registro
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Registrar frequência de alunos
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card - Relatório por Turma */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: (theme) => theme.palette.mode === 'dark' 
                ? '0 2px 8px rgba(0, 0, 0, 0.15)' 
                : '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRadius: 2,
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? 'rgba(255, 255, 255, 0.08)' 
                  : 'rgba(0, 0, 0, 0.04)'
              }
            }}
            onClick={() => handleCardClick('relatorio-turma')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <School sx={{ 
                fontSize: 60, 
                color: '#FFC107', 
                mb: 2,
                display: 'block',
                mx: 'auto'
              }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Relatório por Turma
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Frequência consolidada de turmas
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card - Relatório por Aluno */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: (theme) => theme.palette.mode === 'dark' 
                ? '0 2px 8px rgba(0, 0, 0, 0.15)' 
                : '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRadius: 2,
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? 'rgba(255, 255, 255, 0.08)' 
                  : 'rgba(0, 0, 0, 0.04)'
              }
            }}
            onClick={() => handleCardClick('relatorio-aluno')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <People sx={{ 
                fontSize: 60, 
                color: '#FFC107', 
                mb: 2,
                display: 'block',
                mx: 'auto'
              }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Relatório por Aluno
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Frequência individual de alunos
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card - Estatísticas Gerais */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: '#E0F8E0',
                '& .MuiTypography-root': {
                  color: '#1B5E20'
                },
                '& .MuiSvgIcon-root': {
                  color: '#1B5E20'
                }
              }
            }}
            onClick={() => handleCardClick('estatisticas')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <BarChart sx={{ 
                fontSize: 60, 
                color: '#FFC107', 
                mb: 2,
                display: 'block',
                mx: 'auto'
              }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Estatísticas Gerais
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Métricas e indicadores de frequência
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card - Histórico de Frequência */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: '#E0F8E0',
                '& .MuiTypography-root': {
                  color: '#1B5E20'
                },
                '& .MuiSvgIcon-root': {
                  color: '#1B5E20'
                }
              }
            }}
            onClick={() => handleCardClick('historico')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Timeline sx={{ 
                fontSize: 60, 
                color: '#FFC107', 
                mb: 2,
                display: 'block',
                mx: 'auto'
              }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Histórico de Frequência
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Evolução da frequência ao longo do tempo
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card - Filtros Avançados */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: '#E0F8E0',
                '& .MuiTypography-root': {
                  color: '#1B5E20'
                },
                '& .MuiSvgIcon-root': {
                  color: '#1B5E20'
                }
              }
            }}
            onClick={() => handleCardClick('filtros')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <FilterList sx={{ 
                fontSize: 60, 
                color: '#FFC107', 
                mb: 2,
                display: 'block',
                mx: 'auto'
              }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Filtros Avançados
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Filtrar registros por critérios específicos
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card - Lista de Chamada Impressa */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: '#E0F8E0',
                '& .MuiTypography-root': {
                  color: '#1B5E20'
                },
                '& .MuiSvgIcon-root': {
                  color: '#1B5E20'
                }
              }
            }}
            onClick={() => handleCardClick('lista-chamada')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Print sx={{ 
                fontSize: 60, 
                color: '#FFC107', 
                mb: 2,
                display: 'block',
                mx: 'auto'
              }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Lista de Chamada Impressa
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Listas de chamada por período
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card - Relatório de Certificação */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: '#E0F8E0',
                '& .MuiTypography-root': {
                  color: '#1B5E20'
                },
                '& .MuiSvgIcon-root': {
                  color: '#1B5E20'
                }
              }
            }}
            onClick={() => handleCardClick('certificacao')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Assessment sx={{ 
                fontSize: 60, 
                color: '#FFC107', 
                mb: 2,
                display: 'block',
                mx: 'auto'
              }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Relatório de Certificação
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Análise de frequência para certificação
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card - Relatório Detalhado */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: '#E0F8E0',
                '& .MuiTypography-root': {
                  color: '#1B5E20'
                },
                '& .MuiSvgIcon-root': {
                  color: '#1B5E20'
                }
              }
            }}
            onClick={() => handleCardClick('relatorio-detalhado')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Description sx={{ 
                fontSize: 60, 
                color: '#FFC107', 
                mb: 2,
                display: 'block',
                mx: 'auto'
              }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Relatório Detalhado
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Relatório completo com nomes e observações
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card - Relatório por Aluno */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: '#E0F8E0',
                '& .MuiTypography-root': {
                  color: '#1B5E20'
                },
                '& .MuiSvgIcon-root': {
                  color: '#1B5E20'
                }
              }
            }}
            onClick={() => handleCardClick('relatorio-aluno')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Person sx={{ fontSize: 60, color: '#2E7D32', mb: 2 }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Relatório por Aluno
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Histórico completo de frequência individual
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Card - Relatório por Data */}
        <Grid item xs={12} sm={6} md={4}>
          <Card 
            sx={{ 
              height: 250,
              width: 250,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
                backgroundColor: '#E0F8E0',
                '& .MuiTypography-root': {
                  color: '#1B5E20'
                },
                '& .MuiSvgIcon-root': {
                  color: '#1B5E20'
                }
              }
            }}
            onClick={() => handleCardClick('relatorio-data')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3, px: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <CalendarToday sx={{ 
                fontSize: 60, 
                color: '#FFC107', 
                mb: 2,
                display: 'block',
                mx: 'auto'
              }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Relatório por Data
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                Lista de chamada organizada por data
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Seção de Informações */}

      {/* Dialog Principal */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95%', md: '900px' },
            height: '550px',
            position: 'relative'
          }
        }}
      >
        {/* Cabeçalho */}
        <DialogTitle sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          Registro de Frequência de Alunos
          <IconButton
            onClick={() => setOpenDialog(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Sistema de Abas */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="registro de frequência">
            <Tab label="Seleção" />
            <Tab label="Frequência" />
          </Tabs>
        </Box>

        {/* Conteúdo */}
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px',
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem'
          },
          '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem'
          }
        }}>
          
          {/* Aba 1: Seleção */}
          {tabValue === 0 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 300px' }}>
                  <Autocomplete
                    options={turmasOrdenadas}
                    getOptionLabel={(option) => option.nome || option.codigoTurma || ''}
                    value={turmaSelecionada}
                    onChange={(event, newValue) => {
                      setTurmaSelecionada(newValue);
                    }}
                    filterOptions={(options, { inputValue }) => {
                      const filterValue = inputValue.toLowerCase();
                      return options.filter(option => {
                        const nome = (option.nome || '').toLowerCase();
                        const codigo = (option.codigoTurma || '').toLowerCase();
                        return nome.includes(filterValue) || codigo.includes(filterValue);
                      });
                    }}
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        <Box>
                          <Typography variant="body1">
                            {option.nome || option.codigoTurma}
                          </Typography>
                          {option.codigoTurma && (
                            <Typography variant="caption" color="text.secondary">
                              Código: {option.codigoTurma}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Turma *"
                        placeholder="Digite para buscar..."
                        required
                        error={!turmaSelecionada}
                        helperText={!turmaSelecionada ? "Turma é obrigatória" : ""}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingTurmas ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    loading={loadingTurmas}
                    noOptionsText={loadingTurmas ? "Carregando turmas..." : "Nenhuma turma encontrada"}
                    disabled={loadingTurmas}
                  />
                  {erroTurmas && <Box mt={1}><Alert severity="error">{erroTurmas}</Alert></Box>}
                </Box>
                
                <Box sx={{ flex: '1 1 200px' }}>
                  <TextField
                    fullWidth
                    label="Código da Turma"
                    value={turmaSelecionada ? turmaSelecionada.codigoTurma || 'N/A' : ''}
                    disabled
                    InputProps={{
                      readOnly: true,
                      sx: {
                        backgroundColor: 'grey.100',
                        '& .MuiInputBase-input': {
                          color: 'text.secondary',
                          fontWeight: 'bold'
                        }
                      }
                    }}
                    helperText="Código interno da turma"
                  />
                </Box>
              </Box>

                             <FormControl fullWidth>
                 <InputLabel id="data-aula-label">Data da Aula *</InputLabel>
                 <Select
                   labelId="data-aula-label"
                   label="Data da Aula *"
                   value={dataSelecionada}
                   onChange={e => setDataSelecionada(e.target.value)}
                   disabled={!turmaSelecionada || datasValidas.length === 0}
                   required
                   error={!dataSelecionada && turmaSelecionada}
                 >
                   <MenuItem value="">
                     <em>Selecione uma data...</em>
                   </MenuItem>
                   {datasValidas.map((data) => {
                     const dataObj = new Date(data);
                     const dataFormatada = formatarData(data);
                     const diaSemana = dataObj.toLocaleDateString('pt-BR', { weekday: 'long' });
                     return (
                       <MenuItem key={data} value={data}>
                         {dataFormatada} - {diaSemana}
                       </MenuItem>
                     );
                   })}
                 </Select>
                 {!dataSelecionada && turmaSelecionada && (
                   <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                     Data é obrigatória
                   </Typography>
                 )}
                 {turmaSelecionada && datasValidas.length === 0 && (
                   <Typography variant="caption" color="warning.main" sx={{ mt: 0.5, display: 'block' }}>
                     Nenhuma data válida encontrada para esta turma. Verifique o período e dias da semana.
                   </Typography>
                 )}
                 {turmaSelecionada && datasValidas.length > 0 && (
                   <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                     {datasValidas.length} data(s) disponível(is) no período da turma
                   </Typography>
                 )}
               </FormControl>
            </Box>
          )}

          {/* Aba 2: Frequência */}
          {tabValue === 1 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {!turmaSelecionada || !dataSelecionada ? (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <Typography variant="body1" color="text.secondary">
                    Selecione uma turma e uma data na aba "Seleção" para registrar a frequência.
                  </Typography>
                </Box>
              ) : (
                <>
                  <Typography variant="h6" fontWeight={500} sx={{ 
                    fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' }
                  }}>
                    Alunos da Turma: {turmaSelecionada.nome || turmaSelecionada.codigoTurma} ({alunos.length})
                  </Typography>

                  {loadingAlunos ? (
                    <Box display="flex" justifyContent="center" alignItems="center" flex={1}>
                      <CircularProgress />
                    </Box>
                  ) : erroAlunos ? (
                    <Alert severity="error">{erroAlunos}</Alert>
                  ) : alunos.length === 0 ? (
                    <Box display="flex" justifyContent="center" alignItems="center" flex={1}>
                      <Typography variant="body2" color="grey.400">
                        Nenhum aluno matriculado nesta turma.
                      </Typography>
                    </Box>
                  ) : (
                    <Box flex={1} overflow="auto" border={1} borderColor="grey.300" borderRadius={1} sx={{ 
                      minHeight: { xs: 200, sm: 250, md: 300 }
                    }}>
                      <List dense sx={{ 
                        '& .MuiListItem-root': {
                          padding: { xs: '8px 12px', sm: '12px 16px' },
                          lineHeight: 1.2
                        }
                      }}>
                        {alunos.map((aluno, index) => (
                          <React.Fragment key={aluno.id_cliente}>
                            <ListItem>
                              <ListItemText
                                primary={aluno.nome}
                                secondary={`ID: ${aluno.id_cliente}`}
                                sx={{
                                  '& .MuiListItemText-primary': {
                                    lineHeight: 1.2
                                  },
                                  '& .MuiListItemText-secondary': {
                                    lineHeight: 1.2
                                  }
                                }}
                              />
                              <ListItemSecondaryAction>
                                <Box display="flex" alignItems="center" gap={{ xs: 1, sm: 2 }} sx={{ flexWrap: 'wrap' }}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={presenca[aluno.id_cliente] !== false}
                                        onChange={e => handlePresencaChange(aluno.id_cliente, e.target.checked)}
                                        icon={<Cancel color="error" />}
                                        checkedIcon={<CheckCircle color="success" />}
                                      />
                                    }
                                    label={presenca[aluno.id_cliente] !== false ? "Presente" : "Faltou"}
                                  />
                                  <TextField
                                    size="small"
                                    placeholder="Observação"
                                    value={observacoes[aluno.id_cliente] || ''}
                                    onChange={e => handleObservacaoChange(aluno.id_cliente, e.target.value)}
                                    sx={{ 
                                      width: { xs: 120, sm: 150, md: 200 },
                                      minWidth: 120
                                    }}
                                  />
                                </Box>
                              </ListItemSecondaryAction>
                            </ListItem>
                            {index < alunos.length - 1 && <Divider />}
                          </React.Fragment>
                        ))}
                      </List>
                    </Box>
                  )}
                </>
              )}
            </Box>
          )}
        </DialogContent>

        {/* Footer com Botões */}
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => setTabValue(prev => Math.max(0, prev - 1))}
              disabled={tabValue === 0}
              sx={{ fontSize: '0.875rem', fontWeight: 500, textTransform: 'uppercase' }}
            >
              Anterior
            </Button>
            <Button
              variant="outlined"
              onClick={() => setTabValue(prev => Math.min(1, prev + 1))}
              disabled={tabValue === 1 || !turmaSelecionada || !dataSelecionada}
              sx={{ fontSize: '0.875rem', fontWeight: 500, textTransform: 'uppercase' }}
            >
              Próximo
            </Button>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setOpenDialog(false)}
              sx={{ fontSize: '0.875rem', fontWeight: 500, textTransform: 'uppercase' }}
            >
              FECHAR
            </Button>
            <Button 
              variant="contained" 
              color="primary"
              onClick={salvarFrequencia}
              disabled={salvando || !turmaSelecionada || !dataSelecionada || alunos.length === 0}
              sx={{ fontSize: '0.875rem', fontWeight: 500, textTransform: 'uppercase' }}
            >
              {salvando ? <CircularProgress size={24} /> : "SALVAR"}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog - Lista de Chamada Impressa */}
      <Dialog
        open={openListaChamada}
        onClose={() => setOpenListaChamada(false)}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95%', md: '900px' },
            height: '600px',
            position: 'relative'
          }
        }}
      >
        {/* Cabeçalho */}
        <DialogTitle sx={{ 
          backgroundColor: '#fff3e0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500,
          color: '#e65100'
        }}>
          📋 Lista de Chamada Impressa
          <IconButton
            onClick={() => setOpenListaChamada(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Conteúdo */}
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px'
        }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
          
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            
            {/* Seleção de Turma */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Seleção de Turma
              </Typography>
              <Autocomplete
                options={turmasOrdenadas}
                getOptionLabel={(option) => option.nome || option.codigoTurma || ''}
                value={turmaListaChamada}
                onChange={(event, newValue) => {
                  setTurmaListaChamada(newValue);
                }}
                filterOptions={(options, { inputValue }) => {
                  const filterValue = inputValue.toLowerCase();
                  return options.filter(option => {
                    const nome = (option.nome || '').toLowerCase();
                    const codigo = (option.codigoTurma || '').toLowerCase();
                    return nome.includes(filterValue) || codigo.includes(filterValue);
                  });
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Box>
                      <Typography variant="body1">
                        {option.nome || option.codigoTurma}
                      </Typography>
                      {option.codigoTurma && (
                        <Typography variant="caption" color="text.secondary">
                          Código: {option.codigoTurma}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Turma *"
                    placeholder="Digite para buscar..."
                    required
                    error={!turmaListaChamada}
                    helperText={!turmaListaChamada ? "Turma é obrigatória" : ""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingTurmas ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                loading={loadingTurmas}
                noOptionsText={loadingTurmas ? "Carregando turmas..." : "Nenhuma turma encontrada"}
                disabled={loadingTurmas}
              />
            </Box>

            {/* Período */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Período de Análise
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <DatePicker
                  label="Data Início *"
                  value={dataInicio ? new Date(dataInicio) : null}
                  onChange={(newValue) => {
                    const dataFormatada = newValue ? newValue.toISOString().split('T')[0] : '';
                    setDataInicio(dataFormatada);
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                      error: !dataInicio || (dataInicio && dataFim && dataInicio > dataFim),
                      helperText: !dataInicio 
                        ? "Data de início é obrigatória" 
                        : dataInicio && dataFim && dataInicio > dataFim
                          ? "Data de início deve ser menor ou igual à data de fim"
                          : dataInicio ? formatarData(dataInicio) : "",
                      sx: { flex: '1 1 200px' }
                    }
                  }}
                  format="dd/MM/yyyy"
                />
                <DatePicker
                  label="Data Fim *"
                  value={dataFim ? new Date(dataFim) : null}
                  onChange={(newValue) => {
                    const dataFormatada = newValue ? newValue.toISOString().split('T')[0] : '';
                    setDataFim(dataFormatada);
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                      error: !dataFim || (dataInicio && dataFim && dataInicio > dataFim),
                      helperText: !dataFim 
                        ? "Data de fim é obrigatória" 
                        : dataInicio && dataFim && dataInicio > dataFim
                          ? "Data de fim deve ser maior ou igual à data de início"
                          : dataFim ? formatarData(dataFim) : "",
                      sx: { flex: '1 1 200px' }
                    }
                  }}
                  format="dd/MM/yyyy"
                />
              </Box>
            </Box>

            {/* Botão Carregar */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={carregarListaChamada}
                disabled={loadingListaChamada || !turmaListaChamada || !dataInicio || !dataFim}
                startIcon={loadingListaChamada ? <CircularProgress size={20} /> : <Assessment />}
                sx={{ 
                  fontSize: '1rem', 
                  fontWeight: 500, 
                  textTransform: 'uppercase',
                  px: 4,
                  py: 1.5
                }}
              >
                {loadingListaChamada ? "Carregando..." : "Carregar Dados"}
              </Button>
            </Box>

            {/* Resultados */}
            {dadosListaChamada.length > 0 && (
              <Box>
                <Typography variant="h6" gutterBottom color="success.main">
                  📊 Dados Carregados com Sucesso!
                </Typography>
                <Box sx={{ 
                  backgroundColor: 'success.light', 
                  color: 'success.contrastText',
                  padding: 2, 
                  borderRadius: 1,
                  mb: 2
                }}>
                  <Typography variant="body2">
                    <strong>Turma:</strong> {turmaListaChamada?.nome || turmaListaChamada?.codigoTurma}<br/>
                    <strong>Período:</strong> {dataInicio} a {dataFim}<br/>
                    <strong>Registros encontrados:</strong> {dadosListaChamada.length}
                  </Typography>
                </Box>
                
                <Button
                  variant="contained"
                  color="warning"
                  onClick={imprimirListaChamada}
                  startIcon={<Print />}
                  sx={{ 
                    fontSize: '1rem', 
                    fontWeight: 500, 
                    textTransform: 'uppercase',
                    px: 4,
                    py: 1.5
                  }}
                >
                  🖨️ Imprimir Lista de Chamada
                </Button>
              </Box>
            )}

            {/* Instruções */}
            <Box sx={{ 
              backgroundColor: 'info.light', 
              color: 'info.contrastText',
              padding: 2, 
              borderRadius: 1,
              mt: 2
            }}>
              <Typography variant="h6" gutterBottom>
                📋 Instruções
              </Typography>
              <Typography variant="body2">
                1. <strong>Selecione a turma</strong> desejada para gerar a lista de chamada<br/>
                2. <strong>Defina o período</strong> de análise (data início e fim)<br/>
                3. <strong>Clique em "Carregar Dados"</strong> para buscar os registros<br/>
                4. <strong>Clique em "Imprimir"</strong> para gerar a lista de chamada impressa<br/>
                5. A lista será aberta em uma nova janela para impressão
              </Typography>
            </Box>

          </Box>
          </LocalizationProvider>

        </DialogContent>

        {/* Footer */}
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: '#fff3e0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setOpenListaChamada(false)}
              sx={{ fontSize: '0.875rem', fontWeight: 500, textTransform: 'uppercase' }}
            >
              FECHAR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog - Relatório de Certificação */}
      <Dialog
        open={openCertificacao}
        onClose={() => setOpenCertificacao(false)}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95%', md: '900px' },
            height: '600px',
            position: 'relative'
          }
        }}
      >
        {/* Cabeçalho */}
        <DialogTitle sx={{ 
          backgroundColor: '#e8f5e8',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500,
          color: '#2e7d32'
        }}>
          🎓 Relatório de Certificação
          <IconButton
            onClick={() => setOpenCertificacao(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Conteúdo */}
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px'
        }}>
          
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            
            {/* Seleção de Turma */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Seleção de Turma
              </Typography>
              <Autocomplete
                options={turmasOrdenadas}
                getOptionLabel={(option) => option.nome || option.codigoTurma || ''}
                value={turmaCertificacao}
                onChange={(event, newValue) => {
                  setTurmaCertificacao(newValue);
                }}
                filterOptions={(options, { inputValue }) => {
                  const filterValue = inputValue.toLowerCase();
                  return options.filter(option => {
                    const nome = (option.nome || '').toLowerCase();
                    const codigo = (option.codigoTurma || '').toLowerCase();
                    return nome.includes(filterValue) || codigo.includes(filterValue);
                  });
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Box>
                      <Typography variant="body1">
                        {option.nome || option.codigoTurma}
                      </Typography>
                      {option.codigoTurma && (
                        <Typography variant="caption" color="text.secondary">
                          Código: {option.codigoTurma}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Turma *"
                    placeholder="Digite para buscar..."
                    required
                    error={!turmaCertificacao}
                    helperText={!turmaCertificacao ? "Turma é obrigatória" : ""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingTurmas ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                loading={loadingTurmas}
                noOptionsText={loadingTurmas ? "Carregando turmas..." : "Nenhuma turma encontrada"}
                disabled={loadingTurmas}
              />
            </Box>

            {/* Frequência Mínima */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Critério de Certificação
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                <TextField
                  label="Frequência Mínima (%)"
                  type="number"
                  value={minPresenca}
                  onChange={(e) => setMinPresenca(parseInt(e.target.value) || 75)}
                  inputProps={{ min: 0, max: 100 }}
                  required
                  error={minPresenca < 0 || minPresenca > 100}
                  helperText={minPresenca < 0 || minPresenca > 100 ? "Frequência deve estar entre 0% e 100%" : "Percentual mínimo de presença para aprovação"}
                  sx={{ flex: '1 1 200px' }}
                />
                <Box sx={{ 
                  backgroundColor: 'info.light', 
                  color: 'info.contrastText',
                  padding: 2, 
                  borderRadius: 1,
                  flex: '1 1 300px'
                }}>
                  <Typography variant="body2">
                    <strong>Padrão:</strong> 75% de frequência mínima<br/>
                    <strong>Alunos com frequência ≥ {minPresenca}%</strong> serão aprovados para certificação
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Botão Carregar */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={carregarRelatorioCertificacao}
                disabled={loadingCertificacao || !turmaCertificacao || minPresenca < 0 || minPresenca > 100}
                startIcon={loadingCertificacao ? <CircularProgress size={20} /> : <Assessment />}
                sx={{ 
                  fontSize: '1rem', 
                  fontWeight: 500, 
                  textTransform: 'uppercase',
                  px: 4,
                  py: 1.5
                }}
              >
                {loadingCertificacao ? "Carregando..." : "Gerar Relatório"}
              </Button>
            </Box>

            {/* Resultados */}
            {dadosCertificacao.length > 0 && (
              <Box>
                <Typography variant="h6" gutterBottom color="success.main">
                  📊 Relatório Gerado com Sucesso!
                </Typography>
                
                {/* Estatísticas Rápidas */}
                <Box sx={{ 
                  backgroundColor: 'success.light', 
                  color: 'success.contrastText',
                  padding: 2, 
                  borderRadius: 1,
                  mb: 2
                }}>
                  <Typography variant="body2" gutterBottom>
                    <strong>Turma:</strong> {turmaCertificacao?.nome || turmaCertificacao?.codigoTurma}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    <strong>Frequência Mínima:</strong> {minPresenca}%
                  </Typography>
                  
                  {(() => {
                    const alunosAprovados = dadosCertificacao.filter(aluno => aluno.aprovado);
                    const totalAlunos = dadosCertificacao.length;
                    const totalAprovados = alunosAprovados.length;
                    const percentualAprovacao = totalAlunos > 0 ? ((totalAprovados / totalAlunos) * 100) : 0;
                    
                    return (
                      <>
                        <Typography variant="body2" gutterBottom>
                          <strong>Total de Alunos:</strong> {totalAlunos}
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                          <strong>Alunos Aprovados:</strong> {totalAprovados} ({formatarPercentual(percentualAprovacao)})
                        </Typography>
                        <Typography variant="body2">
                          <strong>Alunos Reprovados:</strong> {totalAlunos - totalAprovados} ({formatarPercentual(100 - percentualAprovacao)})
                        </Typography>
                      </>
                    );
                  })()}
                </Box>
                
                <Button
                  variant="contained"
                  color="success"
                  onClick={imprimirRelatorioCertificacao}
                  startIcon={<Print />}
                  sx={{ 
                    fontSize: '1rem', 
                    fontWeight: 500, 
                    textTransform: 'uppercase',
                    px: 4,
                    py: 1.5
                  }}
                >
                  🖨️ Imprimir Relatório
                </Button>
              </Box>
            )}

            {/* Instruções */}
            <Box sx={{ 
              backgroundColor: 'info.light', 
              color: 'info.contrastText',
              padding: 2, 
              borderRadius: 1,
              mt: 2
            }}>
              <Typography variant="h6" gutterBottom>
                📋 Instruções
              </Typography>
              <Typography variant="body2">
                1. <strong>Selecione a turma</strong> para análise de certificação<br/>
                2. <strong>Defina a frequência mínima</strong> exigida (padrão: 75%)<br/>
                3. <strong>Clique em "Gerar Relatório"</strong> para analisar os dados<br/>
                4. <strong>Clique em "Imprimir"</strong> para gerar o relatório completo<br/>
                5. O relatório mostrará alunos aprovados e reprovados por frequência
              </Typography>
            </Box>

          </Box>

        </DialogContent>

        {/* Footer */}
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: '#e8f5e8',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setOpenCertificacao(false)}
              sx={{ fontSize: '0.875rem', fontWeight: 500, textTransform: 'uppercase' }}
            >
              FECHAR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog - Relatório Detalhado */}
      <Dialog
        open={openDetalhado}
        onClose={() => setOpenDetalhado(false)}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95%', md: '900px' },
            height: '600px',
            position: 'relative'
          }
        }}
      >
        {/* Cabeçalho */}
        <DialogTitle sx={{ 
          backgroundColor: '#f3e5f5',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500,
          color: '#7b1fa2'
        }}>
          📋 Relatório Detalhado
          <IconButton
            onClick={() => setOpenDetalhado(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Conteúdo */}
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px'
        }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            
            {/* Seleção de Turma */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Seleção de Turma
              </Typography>
              <Autocomplete
                options={turmasOrdenadas}
                getOptionLabel={(option) => option.nome || option.codigoTurma || ''}
                value={turmaDetalhado}
                onChange={(event, newValue) => {
                  setTurmaDetalhado(newValue);
                  // Limpar datas quando uma nova turma for selecionada
                  setDataInicioDetalhado('');
                  setDataFimDetalhado('');
                  setDataInicioDetalhadoFormatada('');
                  setDataFimDetalhadoFormatada('');
                  setDadosDetalhado({});
                }}
                filterOptions={(options, { inputValue }) => {
                  const filterValue = inputValue.toLowerCase();
                  return options.filter(option => {
                    const nome = (option.nome || '').toLowerCase();
                    const codigo = (option.codigoTurma || '').toLowerCase();
                    return nome.includes(filterValue) || codigo.includes(filterValue);
                  });
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Box>
                      <Typography variant="body1">
                        {option.nome || option.codigoTurma}
                      </Typography>
                      {option.codigoTurma && (
                        <Typography variant="caption" color="text.secondary">
                          Código: {option.codigoTurma}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Turma *"
                    placeholder="Digite para buscar..."
                    required
                    error={!turmaDetalhado}
                    helperText={!turmaDetalhado ? "Turma é obrigatória" : ""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingTurmas ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                loading={loadingTurmas}
                noOptionsText={loadingTurmas ? "Carregando turmas..." : "Nenhuma turma encontrada"}
                disabled={loadingTurmas}
              />
            </Box>

            {/* Período */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Período de Análise
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <DatePicker
                  label="Data de Início *"
                  value={dataInicioDetalhado ? new Date(dataInicioDetalhado) : null}
                  onChange={(newValue) => {
                    const dataFormatada = newValue ? newValue.toISOString().split('T')[0] : '';
                    setDataInicioDetalhado(dataFormatada);
                    setDataInicioDetalhadoFormatada(formatarDataExibicao(dataFormatada));
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                      error: !dataInicioDetalhado || 
                    (turmaDetalhado?.diaInicio && dataInicioDetalhado < turmaDetalhado.diaInicio) ||
                        (dataInicioDetalhado && dataFimDetalhado && dataInicioDetalhado > dataFimDetalhado),
                      helperText: !dataInicioDetalhado 
                      ? "Data de início é obrigatória" 
                      : turmaDetalhado?.diaInicio && dataInicioDetalhado < turmaDetalhado.diaInicio
                          ? `Deve ser maior ou igual a ${formatarData(turmaDetalhado.diaInicio)}`
                        : dataInicioDetalhado && dataFimDetalhado && dataInicioDetalhado > dataFimDetalhado
                          ? "Data de início deve ser menor ou igual à data de fim"
                            : dataInicioDetalhado ? `📅 ${formatarData(dataInicioDetalhado)}` : "",
                      sx: { flex: '1 1 200px' }
                  }
                  }}
                  format="dd/MM/yyyy"
                  minDate={turmaDetalhado?.diaInicio ? new Date(turmaDetalhado.diaInicio) : undefined}
                  maxDate={turmaDetalhado?.diaFim ? new Date(turmaDetalhado.diaFim) : undefined}
                />
                <DatePicker
                  label="Data de Fim *"
                  value={dataFimDetalhado ? new Date(dataFimDetalhado) : null}
                  onChange={(newValue) => {
                    const dataFormatada = newValue ? newValue.toISOString().split('T')[0] : '';
                    setDataFimDetalhado(dataFormatada);
                    setDataFimDetalhadoFormatada(formatarDataExibicao(dataFormatada));
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                      error: !dataFimDetalhado || 
                    (turmaDetalhado?.diaFim && dataFimDetalhado > turmaDetalhado.diaFim) ||
                        (dataInicioDetalhado && dataFimDetalhado && dataInicioDetalhado > dataFimDetalhado),
                      helperText: !dataFimDetalhado 
                      ? "Data de fim é obrigatória" 
                      : turmaDetalhado?.diaFim && dataFimDetalhado > turmaDetalhado.diaFim
                          ? `Deve ser menor ou igual a ${formatarData(turmaDetalhado.diaFim)}`
                        : dataInicioDetalhado && dataFimDetalhado && dataInicioDetalhado > dataFimDetalhado
                          ? "Data de fim deve ser maior ou igual à data de início"
                            : dataFimDetalhado ? `📅 ${formatarData(dataFimDetalhado)}` : "",
                      sx: { flex: '1 1 200px' }
                  }
                  }}
                  format="dd/MM/yyyy"
                  minDate={turmaDetalhado?.diaInicio ? new Date(turmaDetalhado.diaInicio) : undefined}
                  maxDate={turmaDetalhado?.diaFim ? new Date(turmaDetalhado.diaFim) : undefined}
                />
              </Box>
              
              {/* Exibição das datas formatadas */}
              {(dataInicioDetalhadoFormatada || dataFimDetalhadoFormatada) && (
                <Box sx={{ mt: 1, p: 1, backgroundColor: 'success.light', borderRadius: 1 }}>
                  <Typography variant="caption" color="success.contrastText">
                    <strong>Período Selecionado:</strong> {dataInicioDetalhadoFormatada || 'N/A'} a {dataFimDetalhadoFormatada || 'N/A'}
                  </Typography>
                </Box>
              )}
              
              {turmaDetalhado && (turmaDetalhado.diaInicio || turmaDetalhado.diaFim) && (
                <Box sx={{ mt: 1, p: 1, backgroundColor: 'info.light', borderRadius: 1 }}>
                  <Typography variant="caption" color="info.contrastText">
                    <strong>Período da Turma:</strong> {turmaDetalhado.diaInicio ? formatarData(turmaDetalhado.diaInicio) : 'N/A'} a {turmaDetalhado.diaFim ? formatarData(turmaDetalhado.diaFim) : 'N/A'}
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Botão Carregar */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={carregarRelatorioDetalhado}
                disabled={
                  loadingDetalhado || 
                  !turmaDetalhado || 
                  !dataInicioDetalhado || 
                  !dataFimDetalhado ||
                  (turmaDetalhado?.diaInicio && dataInicioDetalhado && dataInicioDetalhado < turmaDetalhado.diaInicio) ||
                  (turmaDetalhado?.diaFim && dataFimDetalhado && dataFimDetalhado > turmaDetalhado.diaFim) ||
                  (dataInicioDetalhado && dataFimDetalhado && dataInicioDetalhado > dataFimDetalhado)
                }
                startIcon={loadingDetalhado ? <CircularProgress size={20} /> : <Description />}
                sx={{ 
                  fontSize: '1rem', 
                  fontWeight: 500, 
                  textTransform: 'uppercase',
                  px: 4,
                  py: 1.5
                }}

              >
                {loadingDetalhado ? "Carregando..." : "Gerar Relatório"}
              </Button>
            </Box>

            {/* Resultados */}
            {Object.keys(dadosDetalhado).length > 0 && (
              <Box>
                <Typography variant="h6" gutterBottom color="success.main">
                  📊 Relatório Gerado com Sucesso!
                </Typography>
                
                <Button
                  variant="contained"
                  color="success"
                  onClick={imprimirRelatorioDetalhado}
                  startIcon={<Print />}
                  sx={{ 
                    fontSize: '1rem', 
                    fontWeight: 500, 
                    textTransform: 'uppercase',
                    px: 4,
                    py: 1.5
                  }}
                >
                  🖨️ Imprimir Relatório
                </Button>
              </Box>
            )}

            {/* Instruções */}
            <Box sx={{ 
              backgroundColor: 'info.light', 
              color: 'info.contrastText',
              padding: 2, 
              borderRadius: 1,
              mt: 2
            }}>
              <Typography variant="h6" gutterBottom>
                📋 Instruções
              </Typography>
              <Typography variant="body2">
                1. <strong>Selecione a turma</strong> para análise detalhada<br/>
                2. <strong>Defina o período</strong> de início e fim<br/>
                3. <strong>Clique em "Gerar Relatório"</strong> para carregar os dados<br/>
                4. <strong>Clique em "Imprimir"</strong> para gerar o relatório completo<br/>
                5. O relatório mostrará presenças com nomes dos alunos e observações
              </Typography>
            </Box>

          </Box>
          </LocalizationProvider>

        </DialogContent>

        {/* Footer */}
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: '#f3e5f5',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setOpenDetalhado(false)}
              sx={{ fontSize: '0.875rem', fontWeight: 500, textTransform: 'uppercase' }}
            >
              FECHAR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog - Relatório por Turma */}
      <Dialog
        open={openPorTurma}
        onClose={() => setOpenPorTurma(false)}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95%', md: '900px' },
            height: '600px',
            position: 'relative'
          }
        }}
      >
        {/* Cabeçalho */}
        <DialogTitle sx={{ 
          backgroundColor: '#e3f2fd',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500,
          color: '#1976d2'
        }}>
          🎓 Relatório por Turma
          <IconButton
            onClick={() => setOpenPorTurma(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Conteúdo */}
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px'
        }}>
          
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            
            {/* Seleção de Turma */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Seleção de Turma
              </Typography>
              <Autocomplete
                options={turmas}
                getOptionLabel={(option) => option.nome || ''}
                value={turmaPorTurma}
                onChange={(event, newValue) => {
                  setTurmaPorTurma(newValue);
                  // Limpar dados quando uma nova turma for selecionada
                  setDadosPorTurma({});
                }}
                filterOptions={(options, { inputValue }) => {
                  const filterValue = inputValue.toLowerCase();
                  return options.filter(option => {
                    const nome = (option.nome || '').toLowerCase();
                    const codigo = (option.codigoTurma || '').toLowerCase();
                    return nome.includes(filterValue) || codigo.includes(filterValue);
                  });
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Box>
                      <Typography variant="body1">
                        {option.nome}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Código: {option.codigoTurma}
                      </Typography>
                    </Box>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Turma *"
                    placeholder="Digite para buscar..."
                    required
                    error={!turmaPorTurma}
                    helperText={!turmaPorTurma ? "Turma é obrigatória" : ""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingTurmas ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                loading={loadingTurmas}
                noOptionsText={loadingTurmas ? "Carregando turmas..." : "Nenhuma turma encontrada"}
                disabled={loadingTurmas}
              />
            </Box>

            {/* Botão Carregar */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={carregarRelatorioPorTurma}
                disabled={loadingPorTurma || !turmaPorTurma}
                startIcon={loadingPorTurma ? <CircularProgress size={20} /> : <School />}
                sx={{ 
                  fontSize: '1rem', 
                  fontWeight: 500, 
                  textTransform: 'uppercase',
                  px: 4,
                  py: 1.5
                }}
              >
                {loadingPorTurma ? "Carregando..." : "Gerar Relatório"}
              </Button>
            </Box>

            {/* Gráfico de Presenças X Faltas - Todas as Turmas Abertas */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                📊 Gráfico de Presenças X Faltas - Todas as Turmas Abertas
              </Typography>
              
              {loadingGraficoTurmas ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
                  <CircularProgress />
                </Box>
              ) : dadosGraficoTurmas.length > 0 ? (
                <Paper sx={{ p: 3, mb: 2 }}>
                  <Box sx={{ height: 400, width: '100%' }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <RechartsBarChart data={dadosGraficoTurmas}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                          dataKey="nome" 
                          angle={-45}
                          textAnchor="end"
                          height={100}
                          interval={0}
                        />
                        <YAxis />
                        <RechartsTooltip 
                          formatter={(value, name) => [
                            value, 
                            name === 'presencas' ? 'Presenças' : 'Faltas'
                          ]}
                          labelFormatter={(label) => `Turma: ${label}`}
                        />
                        <Legend />
                        <Bar 
                          dataKey="presencas" 
                          fill="#4caf50" 
                          name="Presenças"
                          radius={[4, 4, 0, 0]}
                        />
                        <Bar 
                          dataKey="faltas" 
                          fill="#f44336" 
                          name="Faltas"
                          radius={[4, 4, 0, 0]}
                        />
                      </RechartsBarChart>
                    </ResponsiveContainer>
                  </Box>
                  
                  {/* Resumo do gráfico */}
                  <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <Paper sx={{ p: 2, flex: 1, minWidth: 200, backgroundColor: '#e8f5e8' }}>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                        Total de Presenças
                      </Typography>
                      <Typography variant="h6" fontWeight="bold" color="success.main">
                        {dadosGraficoTurmas.reduce((sum, item) => sum + (item.presencas || 0), 0)}
                      </Typography>
                    </Paper>
                    <Paper sx={{ p: 2, flex: 1, minWidth: 200, backgroundColor: '#ffebee' }}>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                        Total de Faltas
                      </Typography>
                      <Typography variant="h6" fontWeight="bold" color="error.main">
                        {dadosGraficoTurmas.reduce((sum, item) => sum + (item.faltas || 0), 0)}
                      </Typography>
                    </Paper>
                    <Paper sx={{ p: 2, flex: 1, minWidth: 200, backgroundColor: '#e3f2fd' }}>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                        Frequência Geral
                      </Typography>
                      <Typography variant="h6" fontWeight="bold" color="primary.main">
                        {(() => {
                          const totalPresencas = dadosGraficoTurmas.reduce((sum, item) => sum + (item.presencas || 0), 0);
                          const totalFaltas = dadosGraficoTurmas.reduce((sum, item) => sum + (item.faltas || 0), 0);
                          const total = totalPresencas + totalFaltas;
                          return total > 0 ? ((totalPresencas / total) * 100).toFixed(1) + '%' : '0%';
                        })()}
                      </Typography>
                    </Paper>
                  </Box>
                </Paper>
              ) : (
                <Paper sx={{ p: 3, textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                  <Typography variant="body1" color="text.secondary">
                    📊 Nenhuma turma com situação "aberto" encontrada ou dados de frequência não disponíveis.
                  </Typography>
                </Paper>
              )}
            </Box>

            {/* Resultados */}
            {Object.keys(dadosPorTurma).length > 0 && (
              <Box>
                <Typography variant="h6" gutterBottom color="success.main">
                  📊 Relatório Gerado com Sucesso!
                </Typography>
                
                {/* Resumo dos dados */}
                <Box sx={{ 
                  backgroundColor: 'success.light', 
                  color: 'success.contrastText',
                  padding: 2, 
                  borderRadius: 1,
                  mb: 2
                }}>
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>Resumo da Turma:</strong>
                  </Typography>
                  <Typography variant="body2">
                    • <strong>Total de Alunos:</strong> {dadosPorTurma.totalAlunos || 0}<br/>
                    • <strong>Total de Aulas:</strong> {dadosPorTurma.totalAulas || 0}<br/>
                    • <strong>Total de Presenças:</strong> {dadosPorTurma.totalPresencas || 0}<br/>
                    • <strong>Total de Faltas:</strong> {dadosPorTurma.totalFaltas || 0}<br/>
                    • <strong>Frequência Geral:</strong> {dadosPorTurma.totalAulas > 0 ? ((dadosPorTurma.totalPresencas / dadosPorTurma.totalAulas) * 100).toFixed(1) : 0}%
                  </Typography>
                </Box>
                
                <Button
                  variant="contained"
                  color="success"
                  onClick={imprimirRelatorioPorTurma}
                  startIcon={<Print />}
                  sx={{ 
                    fontSize: '1rem', 
                    fontWeight: 500, 
                    textTransform: 'uppercase',
                    px: 4,
                    py: 1.5
                  }}
                >
                  🖨️ Imprimir Relatório Sintético
                </Button>
              </Box>
            )}

            {/* Instruções */}
            <Box sx={{ 
              backgroundColor: 'info.light', 
              color: 'info.contrastText',
              padding: 2, 
              borderRadius: 1,
              mt: 2
            }}>
              <Typography variant="h6" gutterBottom>
                📋 Instruções
              </Typography>
              <Typography variant="body2">
                1. <strong>Visualize o gráfico</strong> de presenças X faltas de todas as turmas abertas<br/>
                2. <strong>Selecione uma turma</strong> no campo acima para relatório detalhado<br/>
                3. <strong>Clique em "Gerar Relatório"</strong> para carregar os dados da turma<br/>
                4. <strong>Visualize o resumo</strong> das estatísticas da turma selecionada<br/>
                5. <strong>Clique em "Imprimir"</strong> para gerar o relatório completo<br/>
                6. O gráfico mostra dados de todas as turmas com situação "aberto"
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        {/* Barra de Ações */}
        <DialogActions sx={{ 
          backgroundColor: '#e3f2fd',
          borderTop: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          bottom: 0,
          justifyContent: 'space-between'
        }}>
          <Button
            onClick={() => setOpenPorTurma(false)}
            color="inherit"
            sx={{ 
              fontSize: '0.875rem', 
              fontWeight: 500, 
              textTransform: 'uppercase',
              px: 2
            }}
          >
            ❌ Fechar
          </Button>
          
          <Box sx={{ display: 'flex', gap: 1 }}>
            {Object.keys(dadosPorTurma).length > 0 && (
              <Button
                variant="outlined"
                color="primary"
                onClick={imprimirRelatorioPorTurma}
                startIcon={<Print />}
                sx={{ 
                  fontSize: '0.875rem', 
                  fontWeight: 500, 
                  textTransform: 'uppercase',
                  px: 2
                }}
              >
                🖨️ Imprimir
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog - Relatório por Aluno */}
      <Dialog
        open={openPorAluno}
        onClose={() => setOpenPorAluno(false)}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95%', md: '900px' },
            height: '600px',
            position: 'relative'
          }
        }}
      >
        {/* Cabeçalho */}
        <DialogTitle sx={{ 
          backgroundColor: '#e3f2fd',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500,
          color: '#1976d2'
        }}>
          👤 Relatório por Aluno
          <IconButton
            onClick={() => setOpenPorAluno(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Conteúdo */}
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px'
        }}>
          
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            
            {/* Seleção de Aluno */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Seleção de Aluno
              </Typography>
              <Autocomplete
                options={clientesOrdenados}
                getOptionLabel={(option) => option.nome_completo || option.nome || ''}
                value={alunoSelecionado}
                onChange={(event, newValue) => {
                  setAlunoSelecionado(newValue);
                  // Limpar dados quando um novo aluno for selecionado
                  setDadosPorAluno([]);
                }}
                filterOptions={(options, { inputValue }) => {
                  const filterValue = inputValue.toLowerCase();
                  return options.filter(option => {
                    const nome = (option.nome_completo || option.nome || '').toLowerCase();
                    const cpf = (option.cpf_cnpj || '').toLowerCase();
                    return nome.includes(filterValue) || cpf.includes(filterValue);
                  });
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Box>
                      <Typography variant="body1">
                        {option.nome_completo || option.nome}
                      </Typography>
                      {option.cpf_cnpj && (
                        <Typography variant="caption" color="text.secondary">
                          CPF: {formatarCPF(option.cpf_cnpj)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Aluno *"
                    placeholder="Digite para buscar..."
                    required
                    error={!alunoSelecionado}
                    helperText={!alunoSelecionado ? "Aluno é obrigatório" : ""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingClientes ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                loading={loadingClientes}
                noOptionsText={loadingClientes ? "Carregando alunos..." : "Nenhum aluno encontrado"}
                disabled={loadingClientes}
              />
            </Box>

            {/* Botão Carregar */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={carregarRelatorioPorAluno}
                disabled={loadingPorAluno || !alunoSelecionado}
                startIcon={loadingPorAluno ? <CircularProgress size={20} /> : <Person />}
                sx={{ 
                  fontSize: '1rem', 
                  fontWeight: 500, 
                  textTransform: 'uppercase',
                  px: 4,
                  py: 1.5
                }}
              >
                {loadingPorAluno ? "Carregando..." : "Gerar Relatório"}
              </Button>
            </Box>

            {/* Resultados */}
            {dadosPorAluno.length > 0 && (
              <Box>
                <Typography variant="h6" gutterBottom color="success.main">
                  📊 Relatório Gerado com Sucesso!
                </Typography>
                
                {/* Resumo dos dados */}
                <Box sx={{ 
                  backgroundColor: 'success.light', 
                  color: 'success.contrastText',
                  padding: 2, 
                  borderRadius: 1,
                  mb: 2
                }}>
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>Resumo do Aluno:</strong>
                  </Typography>
                  <Typography variant="body2">
                    • <strong>Total de Aulas:</strong> {dadosPorAluno.length}<br/>
                    • <strong>Presenças:</strong> {dadosPorAluno.filter(r => r.presente).length}<br/>
                    • <strong>Faltas:</strong> {dadosPorAluno.filter(r => !r.presente).length}<br/>
                    • <strong>Frequência:</strong> {dadosPorAluno.length > 0 ? ((dadosPorAluno.filter(r => r.presente).length / dadosPorAluno.length) * 100).toFixed(1) : 0}%<br/>
                    • <strong>Turmas:</strong> {[...new Set(dadosPorAluno.map(r => r.codigoTurma))].length}
                  </Typography>
                </Box>
                
                <Button
                  variant="contained"
                  color="success"
                  onClick={imprimirRelatorioPorAluno}
                  startIcon={<Print />}
                  sx={{ 
                    fontSize: '1rem', 
                    fontWeight: 500, 
                    textTransform: 'uppercase',
                    px: 4,
                    py: 1.5
                  }}
                >
                  🖨️ Imprimir Relatório Completo
                </Button>
              </Box>
            )}

            {/* Instruções */}
            <Box sx={{ 
              backgroundColor: 'info.light', 
              color: 'info.contrastText',
              padding: 2, 
              borderRadius: 1,
              mt: 2
            }}>
              <Typography variant="h6" gutterBottom>
                📋 Instruções
              </Typography>
              <Typography variant="body2">
                1. <strong>Selecione o aluno</strong> para análise individual<br/>
                2. <strong>Clique em "Gerar Relatório"</strong> para carregar o histórico completo<br/>
                3. <strong>Visualize o resumo</strong> com estatísticas gerais<br/>
                4. <strong>Clique em "Imprimir"</strong> para gerar o relatório detalhado<br/>
                5. O relatório mostrará todas as turmas, presenças e ausências do aluno
              </Typography>
            </Box>

          </Box>

        </DialogContent>

        {/* Footer */}
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: '#e3f2fd',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setOpenPorAluno(false)}
              sx={{ fontSize: '0.875rem', fontWeight: 500, textTransform: 'uppercase' }}
            >
              FECHAR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog - Relatório por Data */}
      <Dialog
        open={openPorData}
        onClose={() => setOpenPorData(false)}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95%', md: '900px' },
            height: '600px',
            position: 'relative'
          }
        }}
      >
        {/* Cabeçalho */}
        <DialogTitle sx={{ 
          backgroundColor: '#e8f5e8',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500,
          color: '#388e3c'
        }}>
          📅 Relatório por Data
          <IconButton
            onClick={() => setOpenPorData(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Conteúdo */}
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px'
        }}>
          
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            
            {/* Seleção de Turma */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Seleção de Turma
              </Typography>
              <Autocomplete
                options={turmasOrdenadas}
                getOptionLabel={(option) => option.nome || option.codigoTurma || ''}
                value={turmaPorData}
                onChange={(event, newValue) => {
                  setTurmaPorData(newValue);
                }}
                filterOptions={(options, { inputValue }) => {
                  const filterValue = inputValue.toLowerCase();
                  return options.filter(option => {
                    const nome = (option.nome || '').toLowerCase();
                    const codigo = (option.codigoTurma || '').toLowerCase();
                    return nome.includes(filterValue) || codigo.includes(filterValue);
                  });
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Box>
                      <Typography variant="body1">
                        {option.nome || option.codigoTurma}
                      </Typography>
                      {option.codigoTurma && (
                        <Typography variant="caption" color="text.secondary">
                          Código: {option.codigoTurma}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Turma *"
                    placeholder="Digite para buscar..."
                    required
                    error={!turmaPorData}
                    helperText={!turmaPorData ? "Turma é obrigatória" : ""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingTurmas ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                loading={loadingTurmas}
                noOptionsText={loadingTurmas ? "Carregando turmas..." : "Nenhuma turma encontrada"}
                disabled={loadingTurmas}
              />
            </Box>

            {/* Botão Carregar */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={carregarRelatorioPorData}
                disabled={loadingPorData || !turmaPorData}
                startIcon={loadingPorData ? <CircularProgress size={20} /> : <CalendarToday />}
                sx={{ 
                  fontSize: '1rem', 
                  fontWeight: 500, 
                  textTransform: 'uppercase',
                  px: 4,
                  py: 1.5
                }}
              >
                {loadingPorData ? "Carregando..." : "Gerar Relatório"}
              </Button>
            </Box>

            {/* Resultados */}
            {Object.keys(dadosPorData).length > 0 && (
              <Box>
                <Typography variant="h6" gutterBottom color="success.main">
                  📊 Relatório Gerado com Sucesso!
                </Typography>
                
                <Button
                  variant="contained"
                  color="success"
                  onClick={imprimirRelatorioPorData}
                  startIcon={<Print />}
                  sx={{ 
                    fontSize: '1rem', 
                    fontWeight: 500, 
                    textTransform: 'uppercase',
                    px: 4,
                    py: 1.5
                  }}
                >
                  🖨️ Imprimir Relatório
                </Button>
              </Box>
            )}

            {/* Instruções */}
            <Box sx={{ 
              backgroundColor: 'info.light', 
              color: 'info.contrastText',
              padding: 2, 
              borderRadius: 1,
              mt: 2
            }}>
              <Typography variant="h6" gutterBottom>
                📋 Instruções
              </Typography>
              <Typography variant="body2">
                1. <strong>Selecione a turma</strong> para análise por data<br/>
                2. <strong>Clique em "Gerar Relatório"</strong> para carregar os dados<br/>
                3. <strong>Clique em "Imprimir"</strong> para gerar o relatório completo<br/>
                4. O relatório mostrará lista de chamada organizada por data
              </Typography>
            </Box>

          </Box>

        </DialogContent>

        {/* Footer */}
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: '#e8f5e8',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setOpenPorData(false)}
              sx={{ fontSize: '0.875rem', fontWeight: 500, textTransform: 'uppercase' }}
            >
              FECHAR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog - Estatísticas Gerais */}
      <Dialog
        open={openEstatisticas}
        onClose={() => setOpenEstatisticas(false)}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95%', md: '900px' },
            height: '600px',
            position: 'relative'
          }
        }}
      >
        {/* Cabeçalho */}
        <DialogTitle sx={{ 
          backgroundColor: '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500,
          color: '#1B5E20'
        }}>
          📊 Estatísticas Gerais
          <IconButton
            onClick={() => setOpenEstatisticas(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Conteúdo */}
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px'
        }}>
          
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            
            {/* Botão Carregar */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={carregarEstatisticas}
                disabled={loadingEstatisticas}
                startIcon={loadingEstatisticas ? <CircularProgress size={20} /> : <BarChart />}
                sx={{ 
                  fontSize: '1rem', 
                  fontWeight: 500, 
                  textTransform: 'uppercase',
                  px: 4,
                  py: 1.5
                }}
              >
                {loadingEstatisticas ? "Carregando..." : "Carregar Estatísticas"}
              </Button>
            </Box>

            {/* Resultados */}
            {Object.keys(dadosEstatisticas).length > 0 && (
              <Box>
                <Typography variant="h6" gutterBottom color="success.main">
                  📈 Estatísticas Carregadas com Sucesso!
                </Typography>
                
                {/* Resumo das estatísticas */}
                <Box sx={{ 
                  backgroundColor: 'success.light', 
                  color: 'success.contrastText',
                  padding: 2, 
                  borderRadius: 1,
                  mb: 2
                }}>
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>Resumo Geral:</strong>
                  </Typography>
                  <Typography variant="body2">
                    • <strong>Total de Turmas:</strong> {dadosEstatisticas.totalTurmas || 0}<br/>
                    • <strong>Total de Alunos:</strong> {dadosEstatisticas.totalAlunos || 0}<br/>
                    • <strong>Total de Aulas:</strong> {dadosEstatisticas.totalAulas || 0}<br/>
                    • <strong>Frequência Média:</strong> {formatarPercentual(dadosEstatisticas.frequenciaMedia || 0)}<br/>
                    • <strong>Período Analisado:</strong> {dadosEstatisticas.periodo || 'Últimos 30 dias'}
                  </Typography>
                </Box>
              </Box>
            )}

            {/* Instruções */}
            <Box sx={{ 
              backgroundColor: 'info.light', 
              color: 'info.contrastText',
              padding: 2, 
              borderRadius: 1,
              mt: 2
            }}>
              <Typography variant="h6" gutterBottom>
                📋 Instruções
              </Typography>
              <Typography variant="body2">
                1. <strong>Clique em "Carregar Estatísticas"</strong> para obter dados gerais<br/>
                2. <strong>Visualize o resumo</strong> das métricas de frequência<br/>
                3. <strong>Analise os indicadores</strong> de performance do sistema<br/>
                4. Os dados são atualizados em tempo real
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        {/* Barra de Ações */}
        <DialogActions sx={{ 
          backgroundColor: '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          bottom: 0,
          justifyContent: 'space-between'
        }}>
          <Button
            onClick={() => setOpenEstatisticas(false)}
            color="inherit"
            sx={{ 
              fontSize: '0.875rem', 
              fontWeight: 500, 
              textTransform: 'uppercase',
              px: 2
            }}
          >
            ❌ Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog - Histórico de Frequência */}
      <Dialog
        open={openHistorico}
        onClose={() => setOpenHistorico(false)}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95%', md: '900px' },
            height: '600px',
            position: 'relative'
          }
        }}
      >
        {/* Cabeçalho */}
        <DialogTitle sx={{ 
          backgroundColor: '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500,
          color: '#1B5E20'
        }}>
          📈 Histórico de Frequência
          <IconButton
            onClick={() => setOpenHistorico(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Conteúdo */}
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px'
        }}>
          
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            
            {/* Seleção de Turma */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Seleção de Turma
              </Typography>
              <Autocomplete
                options={turmas}
                getOptionLabel={(option) => option.nome || ''}
                value={turmaHistorico}
                onChange={(event, newValue) => {
                  setTurmaHistorico(newValue);
                  setDadosHistorico({});
                }}
                filterOptions={(options, { inputValue }) => {
                  const filterValue = inputValue.toLowerCase();
                  return options.filter(option => {
                    const nome = (option.nome || '').toLowerCase();
                    const codigo = (option.codigoTurma || '').toLowerCase();
                    return nome.includes(filterValue) || codigo.includes(filterValue);
                  });
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Box>
                      <Typography variant="body1">
                        {option.nome}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Código: {option.codigoTurma}
                      </Typography>
                    </Box>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Turma *"
                    placeholder="Digite para buscar..."
                    required
                    error={!turmaHistorico}
                    helperText={!turmaHistorico ? "Turma é obrigatória" : ""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingTurmas ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                loading={loadingTurmas}
                noOptionsText={loadingTurmas ? "Carregando turmas..." : "Nenhuma turma encontrada"}
                disabled={loadingTurmas}
              />
            </Box>

            {/* Seleção de Período */}
            <Box>
              <Typography variant="h6" gutterBottom color="primary">
                Período de Análise
              </Typography>
              <FormControl fullWidth>
                <InputLabel>Período *</InputLabel>
                <Select
                  value={periodoHistorico}
                  onChange={(e) => setPeriodoHistorico(e.target.value)}
                  label="Período *"
                  required
                >
                  <MenuItem value="7">Últimos 7 dias</MenuItem>
                  <MenuItem value="30">Últimos 30 dias</MenuItem>
                  <MenuItem value="90">Últimos 90 dias</MenuItem>
                  <MenuItem value="365">Últimos 365 dias</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Botão Carregar */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={carregarHistorico}
                disabled={loadingHistorico || !turmaHistorico}
                startIcon={loadingHistorico ? <CircularProgress size={20} /> : <Timeline />}
                sx={{ 
                  fontSize: '1rem', 
                  fontWeight: 500, 
                  textTransform: 'uppercase',
                  px: 4,
                  py: 1.5
                }}
              >
                {loadingHistorico ? "Carregando..." : "Carregar Histórico"}
              </Button>
            </Box>

            {/* Resultados */}
            {Object.keys(dadosHistorico).length > 0 && (
              <Box>
                <Typography variant="h6" gutterBottom color="success.main">
                  📊 Histórico Carregado com Sucesso!
                </Typography>
                
                {/* Resumo do histórico */}
                <Box sx={{ 
                  backgroundColor: 'success.light', 
                  color: 'success.contrastText',
                  padding: 2, 
                  borderRadius: 1,
                  mb: 2
                }}>
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>Resumo do Histórico:</strong>
                  </Typography>
                  <Typography variant="body2">
                    • <strong>Período Analisado:</strong> {periodoHistorico} dias<br/>
                    • <strong>Total de Registros:</strong> {dadosHistorico.totalRegistros || 0}<br/>
                    • <strong>Frequência Média:</strong> {formatarPercentual(dadosHistorico.frequenciaMedia || 0)}<br/>
                    • <strong>Tendência:</strong> {dadosHistorico.tendencia || 'Estável'}
                  </Typography>
                </Box>
              </Box>
            )}

            {/* Instruções */}
            <Box sx={{ 
              backgroundColor: 'info.light', 
              color: 'info.contrastText',
              padding: 2, 
              borderRadius: 1,
              mt: 2
            }}>
              <Typography variant="h6" gutterBottom>
                📋 Instruções
              </Typography>
              <Typography variant="body2">
                1. <strong>Selecione uma turma</strong> para análise histórica<br/>
                2. <strong>Escolha o período</strong> de análise (7, 30, 90 ou 365 dias)<br/>
                3. <strong>Clique em "Carregar Histórico"</strong> para obter os dados<br/>
                4. <strong>Analise a evolução</strong> da frequência ao longo do tempo
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        {/* Barra de Ações */}
        <DialogActions sx={{ 
          backgroundColor: '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          bottom: 0,
          justifyContent: 'space-between'
        }}>
          <Button
            onClick={() => setOpenHistorico(false)}
            color="inherit"
            sx={{ 
              fontSize: '0.875rem', 
              fontWeight: 500, 
              textTransform: 'uppercase',
              px: 2
            }}
          >
            ❌ Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog - Filtros Avançados */}
      <Dialog
        open={openFiltros}
        onClose={() => setOpenFiltros(false)}
        maxWidth="lg"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95%', md: '1100px' },
            maxHeight: '90vh',
            height: 'auto',
            position: 'relative'
          }
        }}
      >
        {/* Cabeçalho */}
        <DialogTitle sx={{ 
          backgroundColor: '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500,
          color: '#1B5E20'
        }}>
          🔍 Filtros Avançados
          <IconButton
            onClick={() => setOpenFiltros(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Conteúdo */}
        <DialogContent sx={{ 
          overflow: 'auto',
          padding: 3,
          '&.MuiDialogContent-root': {
            paddingTop: 3
          }
        }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
          
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            
            {/* Filtros */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              
              {/* Linha 1: Turma */}
              <Box>
                <Typography variant="h6" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 2, borderBottom: 1, borderColor: 'divider', pb: 1 }}>
                  📚 Seleção de Turma
                </Typography>
                <Typography variant="subtitle2" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 1 }}>
                  Turma
                </Typography>
                <Autocomplete
                  options={turmas}
                  getOptionLabel={(option) => option.nome || ''}
                  value={filtrosConfig.turma}
                  onChange={(event, newValue) => {
                    setFiltrosConfig(prev => ({ ...prev, turma: newValue }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Turma"
                      placeholder="Selecione uma turma..."
                      size="medium"
                      sx={{ '& .MuiInputBase-root': { fontSize: '1rem' } }}
                    />
                  )}
                />
              </Box>

              {/* Linha 2: Aluno */}
              <Box>
                <Typography variant="h6" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 2, borderBottom: 1, borderColor: 'divider', pb: 1 }}>
                  👤 Seleção de Aluno
                </Typography>
                <Typography variant="subtitle2" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 1 }}>
                  Aluno
                </Typography>
                <Autocomplete
                  options={clientesOrdenados}
                  getOptionLabel={(option) => option.nome_completo || option.nome || ''}
                  value={filtrosConfig.aluno}
                  onChange={(event, newValue) => {
                    setFiltrosConfig(prev => ({ ...prev, aluno: newValue }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Aluno"
                      placeholder="Selecione um aluno..."
                      size="medium"
                      sx={{ '& .MuiInputBase-root': { fontSize: '1rem' } }}
                    />
                  )}
                />
              </Box>

              {/* Linha 3: Datas e Status */}
              <Box>
                <Typography variant="h6" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 2, borderBottom: 1, borderColor: 'divider', pb: 1 }}>
                  📅 Período e Status
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 1 }}>
                  Data de Início
                </Typography>
                    <DatePicker
                  label="Data de Início"
                      value={filtrosConfig.dataInicio ? new Date(filtrosConfig.dataInicio) : null}
                      onChange={(newValue) => {
                        const dataFormatada = newValue ? newValue.toISOString().split('T')[0] : '';
                        setFiltrosConfig(prev => ({ ...prev, dataInicio: dataFormatada }));
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: 'medium',
                          error: filtrosConfig.dataInicio && filtrosConfig.dataFim && filtrosConfig.dataInicio > filtrosConfig.dataFim,
                          helperText: filtrosConfig.dataInicio 
                            ? `📅 ${formatarData(filtrosConfig.dataInicio)}` 
                            : 'Selecione a data de início do período',
                          sx: { '& .MuiInputBase-root': { fontSize: '1rem' } }
                        }
                      }}
                      format="dd/MM/yyyy"
                />
              </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 1 }}>
                  Data de Fim
                </Typography>
                    <DatePicker
                  label="Data de Fim"
                      value={filtrosConfig.dataFim ? new Date(filtrosConfig.dataFim) : null}
                      onChange={(newValue) => {
                        const dataFormatada = newValue ? newValue.toISOString().split('T')[0] : '';
                        setFiltrosConfig(prev => ({ ...prev, dataFim: dataFormatada }));
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: 'medium',
                          error: filtrosConfig.dataInicio && filtrosConfig.dataFim && filtrosConfig.dataInicio > filtrosConfig.dataFim,
                          helperText: filtrosConfig.dataFim 
                            ? `📅 ${formatarData(filtrosConfig.dataFim)}` 
                            : 'Selecione a data de fim do período',
                          sx: { '& .MuiInputBase-root': { fontSize: '1rem' } }
                        }
                      }}
                      format="dd/MM/yyyy"
                />
              </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 1 }}>
                  Status de Presença
                </Typography>
                    <FormControl fullWidth size="medium">
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={filtrosConfig.statusPresenca}
                    onChange={(e) => setFiltrosConfig(prev => ({ ...prev, statusPresenca: e.target.value }))}
                    label="Status"
                        sx={{ fontSize: '1rem' }}
                  >
                    <MenuItem value="todos">Todos</MenuItem>
                    <MenuItem value="presente">Presente</MenuItem>
                    <MenuItem value="ausente">Ausente</MenuItem>
                  </Select>
                </FormControl>
                  </Grid>
              </Grid>

                {/* Exibição do período selecionado */}
                {filtrosConfig.dataInicio && filtrosConfig.dataFim && (
                  <Box sx={{ 
                    mt: 2, 
                    p: 2, 
                    backgroundColor: 'success.light', 
                    borderRadius: 1,
                    border: '1px solid',
                    borderColor: 'success.main'
                  }}>
                    <Typography variant="body2" color="success.contrastText" sx={{ fontWeight: 500 }}>
                      📅 <strong>Período Selecionado:</strong> {formatarData(filtrosConfig.dataInicio)} a {formatarData(filtrosConfig.dataFim)}
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Linha 4: Frequências */}
              <Box>
                <Typography variant="h6" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 2, borderBottom: 1, borderColor: 'divider', pb: 1 }}>
                  📊 Critérios de Frequência
                </Typography>
                <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 1 }}>
                  Frequência Mínima (%)
                </Typography>
                <TextField
                  type="number"
                  fullWidth
                  value={filtrosConfig.frequenciaMinima}
                  onChange={(e) => setFiltrosConfig(prev => ({ ...prev, frequenciaMinima: e.target.value }))}
                      label="Frequência Mínima (%)"
                  inputProps={{ min: 0, max: 100 }}
                      size="medium"
                      sx={{ '& .MuiInputBase-root': { fontSize: '1rem' } }}
                      InputProps={{
                        endAdornment: <Typography variant="body2" color="text.secondary">%</Typography>
                      }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" gutterBottom color="primary" sx={{ fontWeight: 600, mb: 1 }}>
                  Frequência Máxima (%)
                </Typography>
                <TextField
                  type="number"
                  fullWidth
                  value={filtrosConfig.frequenciaMaxima}
                  onChange={(e) => setFiltrosConfig(prev => ({ ...prev, frequenciaMaxima: e.target.value }))}
                      label="Frequência Máxima (%)"
                  inputProps={{ min: 0, max: 100 }}
                      size="medium"
                      sx={{ '& .MuiInputBase-root': { fontSize: '1rem' } }}
                      InputProps={{
                        endAdornment: <Typography variant="body2" color="text.secondary">%</Typography>
                      }}
                />
              </Grid>
            </Grid>
              </Box>
            </Box>

            {/* Botão Aplicar Filtros */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={aplicarFiltros}
                disabled={loadingFiltros}
                startIcon={loadingFiltros ? <CircularProgress size={20} /> : <FilterList />}
                sx={{ 
                  fontSize: '1rem', 
                  fontWeight: 500, 
                  textTransform: 'uppercase',
                  px: 4,
                  py: 1.5
                }}
              >
                {loadingFiltros ? "Aplicando..." : "Aplicar Filtros"}
              </Button>
            </Box>

            {/* Resultados */}
            {resultadosFiltros.length > 0 && (
              <Box>
                <Typography variant="h6" gutterBottom color="success.main">
                  🔍 Filtros Aplicados com Sucesso!
                </Typography>
                
                <Typography variant="body2" gutterBottom>
                  <strong>Resultados encontrados:</strong> {resultadosFiltros.length} registros
                </Typography>
              </Box>
            )}

            {/* Instruções */}
            <Box sx={{ 
              backgroundColor: 'info.light', 
              color: 'info.contrastText',
              padding: 2, 
              borderRadius: 1,
              mt: 2
            }}>
              <Typography variant="h6" gutterBottom>
                📋 Instruções
              </Typography>
              <Typography variant="body2">
                1. <strong>Configure os filtros</strong> conforme sua necessidade<br/>
                2. <strong>Preencha os campos</strong> que deseja filtrar<br/>
                3. <strong>Clique em "Aplicar Filtros"</strong> para buscar os resultados<br/>
                4. <strong>Analise os resultados</strong> encontrados
              </Typography>
            </Box>
          </Box>
          </LocalizationProvider>
        </DialogContent>

        {/* Barra de Ações */}
        <DialogActions sx={{ 
          backgroundColor: '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          bottom: 0,
          justifyContent: 'space-between'
        }}>
          <Button
            onClick={() => setOpenFiltros(false)}
            color="inherit"
            sx={{ 
              fontSize: '0.875rem', 
              fontWeight: 500, 
              textTransform: 'uppercase',
              px: 2
            }}
          >
            ❌ Fechar
          </Button>
        </DialogActions>
      </Dialog>
      </Box> {/* Fechamento do Box interno com margens */}
    </Box>
    </AcessoRestrito>
  );
} 